import { ColorVariables } from '@group-link-one/gl-ui/sonarprint';

const FallbackArt: React.FC = () => (
  <svg width='1161.478' height='834.032' viewBox='0 0 1161.478 834.032' className='svg-foreground'>
    <defs>
      <linearGradient
        id='linear-gradient'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop
          offset='0'
          stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          stop-opacity='0.8'
        />
        <stop
          offset='1'
          stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          stop-opacity='0'
        />
      </linearGradient>
      <linearGradient
        id='linear-gradient-4'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fff' />
        <stop offset='1' stop-color='#0fa' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-5'
        y1='0.5'
        x2='1'
        y2='0.5'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fff' />
        <stop offset='0.23' stop-color='#fff' />
        <stop offset='1' stop-color='#0fa' />
      </linearGradient>
      <linearGradient id='linear-gradient-7' x1='0' y1='0.5' x2='131.56' y2='0.5' />
      <linearGradient id='linear-gradient-8' x1='-0.012' y1='0.5' x2='1.008' y2='0.5' />
      <linearGradient id='linear-gradient-9' x1='-130.858' y1='0.5' x2='1' y2='0.5' />
      <linearGradient
        id='linear-gradient-10'
        x1='0.5'
        x2='-0.629'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE} />
        <stop offset='1' stop-color='#639' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-11'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE} />
        <stop offset='1' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE_25} />
      </linearGradient>
      <linearGradient
        id='linear-gradient-12'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fff' />
        <stop offset='1' stop-color={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND} />
      </linearGradient>
      <linearGradient
        id='linear-gradient-13'
        x1='0.5'
        x2='0'
        y2='0.591'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE} />
        <stop offset='0' stop-color='#fff' />
        <stop offset='1' stop-color={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND} />
      </linearGradient>
      <linearGradient
        id='linear-gradient-14'
        x1='0.5'
        y1='-0.732'
        x2='0.5'
        y2='1.047'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#639' />
        <stop offset='1' stop-color='#331a4d' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-15'
        x1='0.5'
        y1='0.77'
        x2='0.5'
        y2='0.167'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#ff759a' stop-opacity='0.78' />
        <stop offset='0.556' stop-color='#fea4bc' stop-opacity='0' />
        <stop offset='1' stop-color='#fc3f72' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-16'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fc3f72' />
        <stop offset='1' stop-color='#ffdee0' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-17'
        x1='0.5'
        x2='0.5'
        y2='1'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fc3f72' />
        <stop offset='1' stop-color='#fea7a8' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-18'
        x1='0.5'
        y1='0.799'
        x2='0.5'
        y2='0.122'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fc3f72' />
        <stop offset='1' stop-color='#fedadd' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-19'
        x1='0.604'
        y1='0.501'
        x2='0.933'
        y2='0.497'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#fcbf95' />
        <stop offset='1' stop-color='#ffdda6' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-20'
        x1='0.361'
        y1='0.517'
        x2='0.78'
        y2='0.456'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#3a1154' />
        <stop offset='1' stop-color='#442f84' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-21'
        x1='0.183'
        y1='0.554'
        x2='0.626'
        y2='0.457'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#3a1154' />
        <stop offset='1' stop-color='#774a84' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-22'
        x1='1'
        y1='1.173'
        x2='0'
        y2='0.686'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#639' />
        <stop offset='1' stop-color='#0098ff' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-23'
        y1='0.5'
        x2='1'
        y2='0.5'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND} />
        <stop offset='0.578' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE} />
        <stop offset='1' stop-color={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE} />
      </linearGradient>
      <linearGradient
        id='linear-gradient-24'
        x1='0.305'
        y1='0.5'
        x2='0.891'
        y2='0.5'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#40e6f9' />
        <stop offset='0.31' stop-color='#fff' />
        <stop offset='1' stop-color={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND} />
      </linearGradient>
    </defs>
    <g id='Group_11343' data-name='Group 11343' transform='translate(-451.214 -178.185)'>
      <g id='Layer_1' data-name='Layer 1' transform='translate(451.214 375.959)'>
        <g id='Group_4834' data-name='Group 4834' transform='translate(855.43 14.11)'>
          <path
            id='Path_14285'
            data-name='Path 14285'
            d='M1167.515,371.4l22.094,12.84,22.239-12.84-22.094-12.84Z'
            transform='translate(-1167.515 -318.401)'
            fill='url(#linear-gradient)'
          />
          <path
            id='Path_14222'
            data-name='Path 14222'
            d='M1167.515,369.354l.081,28.4,22.094,12.84-.08-28.4Z'
            transform='translate(-1167.515 -356.514)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14223'
            data-name='Path 14223'
            d='M1186.08,382.194l.081,28.4,22.239-12.84-.08-28.4Z'
            transform='translate(-1163.986 -356.514)'
            fill='#0fa'
          />
          <path
            id='Path_14224'
            data-name='Path 14224'
            d='M1167.515,371.4l22.094,12.84,22.239-12.84-22.094-12.84Z'
            transform='translate(-1167.515 -358.565)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <g id='Group_4835' data-name='Group 4835' transform='translate(0 314.665)'>
          <path
            id='Path_14283'
            data-name='Path 14283'
            d='M464.934,390.209l21.134,12.282,21.272-12.282-21.134-12.282Z'
            transform='translate(-464.934 -337.762)'
            fill='url(#linear-gradient)'
          />
          <path
            id='Path_14225'
            data-name='Path 14225'
            d='M464.934,388.247l.077,27.168L486.145,427.7l-.077-27.168Z'
            transform='translate(-464.934 -375.965)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14226'
            data-name='Path 14226'
            d='M482.692,400.528l.077,27.168,21.272-12.282-.077-27.168Z'
            transform='translate(-461.558 -375.965)'
            fill='#0fa'
          />
          <path
            id='Path_14227'
            data-name='Path 14227'
            d='M464.934,390.209l21.134,12.282,21.272-12.282-21.134-12.282Z'
            transform='translate(-464.934 -377.927)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <g id='Group_4836' data-name='Group 4836' transform='translate(172.91 72.807)'>
          <path
            id='Path_14284'
            data-name='Path 14284'
            d='M599.557,417.822,620.691,430.1l21.272-12.282L620.83,405.541Z'
            transform='translate(-599.557 -368.166)'
            fill='url(#linear-gradient)'
          />
          <path
            id='Path_14228'
            data-name='Path 14228'
            d='M599.557,415.86l.077,27.168,21.134,12.282-.077-27.168Z'
            transform='translate(-599.489 -403.579)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14229'
            data-name='Path 14229'
            d='M617.315,428.142l.077,27.168,21.272-12.282-.077-27.168Z'
            transform='translate(-596.112 -403.579)'
            fill='#0fa'
          />
          <path
            id='Path_14230'
            data-name='Path 14230'
            d='M599.557,417.822,620.691,430.1l21.272-12.282L620.83,405.541Z'
            transform='translate(-599.489 -405.541)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14231'
          data-name='Path 14231'
          d='M532.823,405.971a31.544,31.544,0,0,1,16.745,4.8l74.683,46.752a1.137,1.137,0,1,1-1.207,1.928l-74.683-46.752a29.342,29.342,0,0,0-29.351-.993L493.49,425.367a1.137,1.137,0,0,1-1.072-2.006l25.52-13.666A31.528,31.528,0,0,1,532.823,405.971Z'
          transform='translate(-449.333 -89.951)'
          fill='#fff'
        />
        <path
          id='Path_14232'
          data-name='Path 14232'
          d='M754.6,510.677a1.183,1.183,0,0,1-.594-.159L626.387,436.911a1.19,1.19,0,1,1,1.19-2.061L755.2,508.455a1.191,1.191,0,0,1-.6,2.222Z'
          transform='translate(-421.59 -327.192)'
          fill='#fff'
        />
        <g id='Group_4837' data-name='Group 4837' transform='translate(331.823 171.516)'>
          <path
            id='Path_14233'
            data-name='Path 14233'
            d='M733.025,494.736l.047,16.465,12.808,7.443-.047-16.465Z'
            transform='translate(-733.025 -487.293)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14234'
            data-name='Path 14234'
            d='M743.787,502.179l.047,16.465,12.892-7.443-.047-16.465Z'
            transform='translate(-730.979 -487.292)'
            fill='#0fa'
          />
          <path
            id='Path_14235'
            data-name='Path 14235'
            d='M733.025,495.925l12.808,7.443,12.892-7.443-12.808-7.443Z'
            transform='translate(-733.025 -488.481)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14236'
          data-name='Path 14236'
          d='M1127.2,496.987a1.19,1.19,0,0,1-.575-2.233l124.613-71.606a1.1,1.1,0,0,1,.18-.08,5.216,5.216,0,0,0,3.519-4.808,6.992,6.992,0,0,0-4.05-6.659l-45.093-21.685a1.19,1.19,0,1,1,1.032-2.146l45.092,21.685a9.369,9.369,0,0,1,5.4,8.937,7.524,7.524,0,0,1-5.012,6.886l-124.53,71.56A1.186,1.186,0,0,1,1127.2,496.987Z'
          transform='translate(-326.489 -335.875)'
          fill='#0fa'
        />
        <path
          id='Path_14237'
          data-name='Path 14237'
          d='M1116.43,550.83'
          transform='translate(-328.309 -305.111)'
          fill='none'
          stroke='#707070'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='2'
        />
        <path
          id='Path_14238'
          data-name='Path 14238'
          d='M1116.78,563.172'
          transform='translate(-328.243 -302.765)'
          fill='none'
          stroke='#707070'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-width='2'
        />
        <path
          id='Path_14239'
          data-name='Path 14239'
          d='M990.644,945.1a1.191,1.191,0,0,1-.643-2.193l82.906-52.954a9.786,9.786,0,0,0-.448-16.763L692.656,658.229a11,11,0,0,1,.126-19.215l102.691-56.342a30.528,30.528,0,0,0,.8-53.075L760.43,508.312a1.19,1.19,0,1,1,1.216-2.045l35.839,21.283a32.909,32.909,0,0,1-.866,57.21L693.928,641.1a8.618,8.618,0,0,0-.1,15.056l379.8,214.965a12.165,12.165,0,0,1,.557,20.84l-82.905,52.955A1.19,1.19,0,0,1,990.644,945.1Z'
          transform='translate(-409.939 -313.616)'
          fill='url(#linear-gradient-4)'
        />
        <path
          id='Path_14240'
          data-name='Path 14240'
          d='M1533.741,610.091a1.175,1.175,0,0,1-.55-.136L1036,349.579a30.335,30.335,0,0,0-26.589.476l-226.464,114.6a1.19,1.19,0,1,1-1.073-2.124l226.464-114.6a32.726,32.726,0,0,1,28.715-.486l497.238,260.4a1.19,1.19,0,0,1-.553,2.245Z'
          transform='translate(-392.039 -344.365)'
          fill='url(#linear-gradient-5)'
        />
        <g id='Group_4838' data-name='Group 4838' transform='translate(782.784 145.014)'>
          <path
            id='Path_14241'
            data-name='Path 14241'
            d='M1111.946,472.467l.047,16.465,12.808,7.443-.047-16.465Z'
            transform='translate(-1111.946 -465.024)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14242'
            data-name='Path 14242'
            d='M1122.707,479.91l.047,16.465,12.892-7.443-.047-16.465Z'
            transform='translate(-1109.899 -465.024)'
            fill='#0fa'
          />
          <path
            id='Path_14243'
            data-name='Path 14243'
            d='M1111.946,473.656l12.808,7.443,12.892-7.443-12.808-7.443Z'
            transform='translate(-1111.946 -466.213)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14244'
          data-name='Path 14244'
          d='M816.171,760.71a1.19,1.19,0,0,1-.6-2.221l53.39-30.857a1.19,1.19,0,1,1,1.19,2.061l-53.39,30.857A1.184,1.184,0,0,1,816.171,760.71Z'
          transform='translate(-385.622 -271.528)'
          fill='#0fa'
        />
        <g id='Group_4839' data-name='Group 4839' transform='translate(401.917 469.5)'>
          <path
            id='Path_14245'
            data-name='Path 14245'
            d='M791.923,747.439l.064,22.581,17.566,10.208-.064-22.581Z'
            transform='translate(-791.923 -737.231)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14246'
            data-name='Path 14246'
            d='M806.683,757.647l.064,22.581,17.681-10.208-.064-22.581Z'
            transform='translate(-789.117 -737.231)'
            fill='#0fa'
          />
          <path
            id='Path_14247'
            data-name='Path 14247'
            d='M791.923,749.07l17.566,10.208L827.17,749.07,809.6,738.862Z'
            transform='translate(-791.923 -738.862)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14248'
          data-name='Path 14248'
          d='M695.647,835.787a1.19,1.19,0,0,1-.6-2.221l124.812-72.133a1.19,1.19,0,1,1,1.19,2.061L696.241,835.627A1.181,1.181,0,0,1,695.647,835.787Z'
          transform='translate(-408.536 -265.101)'
          fill='#0fa'
        />
        <g id='Group_4840' data-name='Group 4840' transform='translate(280.743 546.026)'>
          <path
            id='Path_14249'
            data-name='Path 14249'
            d='M690.106,809.417l.047,16.465,12.808,7.443-.047-16.465Z'
            transform='translate(-690.106 -801.974)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14250'
            data-name='Path 14250'
            d='M700.868,816.86l.047,16.465,12.892-7.443-.047-16.465Z'
            transform='translate(-688.06 -801.974)'
            fill='#0fa'
          />
          <path
            id='Path_14251'
            data-name='Path 14251'
            d='M690.106,810.606l12.808,7.443,12.892-7.443L703,803.163Z'
            transform='translate(-690.106 -803.163)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14252'
          data-name='Path 14252'
          d='M1133.131,555.115a1.178,1.178,0,0,1-.573-.149l-50.436-27.873a10.8,10.8,0,0,1-.3-18.738l44.62-26.566a1.19,1.19,0,0,1,1.217,2.046l-44.62,26.566a8.424,8.424,0,0,0,.233,14.61l50.436,27.873a1.19,1.19,0,0,1-.576,2.232Z'
          transform='translate(-335.893 -318.27)'
          fill='#0fa'
        />
        <path
          id='Path_14253'
          data-name='Path 14253'
          d='M1124.7,558.443a1.19,1.19,0,0,1-.635-2.2,7.343,7.343,0,0,0-.357-12.64,1.189,1.189,0,0,1,1.149-2.083,9.723,9.723,0,0,1,.475,16.738A1.2,1.2,0,0,1,1124.7,558.443Z'
          transform='translate(-327.043 -306.909)'
          fill='#0fa'
        />
        <path
          id='Path_14254'
          data-name='Path 14254'
          d='M1068.149,598.388a1.189,1.189,0,0,1-.635-2.2l67.222-42.292a1.19,1.19,0,0,1,1.268,2.015l-67.223,42.292A1.181,1.181,0,0,1,1068.149,598.388Z'
          transform='translate(-337.715 -304.562)'
          fill='#0fa'
        />
        <g id='Group_4841' data-name='Group 4841' transform='translate(709.207 284.67)'>
          <path
            id='Path_14255'
            data-name='Path 14255'
            d='M1050.123,589.813l.047,16.465,12.808,7.443-.047-16.465Z'
            transform='translate(-1050.123 -582.37)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14256'
            data-name='Path 14256'
            d='M1060.885,597.256l.047,16.464,12.892-7.443-.047-16.465Z'
            transform='translate(-1048.077 -582.37)'
            fill='#0fa'
          />
          <path
            id='Path_14257'
            data-name='Path 14257'
            d='M1050.123,591l12.808,7.443L1075.823,591l-12.808-7.443Z'
            transform='translate(-1050.123 -583.559)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
        <path
          id='Path_14258'
          data-name='Path 14258'
          d='M1286.348,830.568a1.2,1.2,0,0,1-.621-.175L1029.685,677.344a32.906,32.906,0,0,1-2.241-56.65l33.723-21.216a1.19,1.19,0,0,1,1.267,2.015L1028.723,622.7a30.527,30.527,0,0,0,2.146,52.578l256.1,153.084a1.19,1.19,0,0,1-.622,2.2Z'
          transform='translate(-348.096 -295.897)'
          fill='#0fa'
        />
        <g id='Group_4842' data-name='Group 4842' transform='translate(872.091 468.842)'>
          <path
            id='Path_14286'
            data-name='Path 14286'
            d='M1225.469,778.29l21.134,12.282,21.272-12.282-21.134-12.282Z'
            transform='translate(-1225.469 -725.843)'
            fill='url(#linear-gradient)'
          />
          <path
            id='Path_14259'
            data-name='Path 14259'
            d='M1225.469,776.328l.077,27.168,21.134,12.282-.077-27.168Z'
            transform='translate(-1225.469 -764.046)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_14260'
            data-name='Path 14260'
            d='M1243.227,788.609l.077,27.168,21.272-12.281-.077-27.168Z'
            transform='translate(-1222.093 -764.046)'
            fill='#0fa'
          />
          <path
            id='Path_14261'
            data-name='Path 14261'
            d='M1225.469,778.29l21.134,12.282,21.272-12.282-21.134-12.282Z'
            transform='translate(-1225.469 -766.008)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
        </g>
      </g>
      <g id='Layer_2' data-name='Layer 2' transform='translate(608.202 178.185)'>
        <path
          id='Path_14287'
          data-name='Path 14287'
          d='M641.477,240,381.665,386.338s-22.323,13.642-50.226-3.72-76.269-44.026-76.269-44.026'
          transform='translate(-15.174 -22.353)'
          fill='none'
          stroke='#fff'
          stroke-linecap='round'
          stroke-width='2.5'
          stroke-dasharray='6 6'
        />
        <g id='Group_4843' data-name='Group 4843' transform='translate(75.35 563.895)'>
          <path
            id='Path_14262'
            data-name='Path 14262'
            d='M653.177,684.314a1.172,1.172,0,0,1-.608-.169l-2.555-1.523a1.19,1.19,0,1,1,1.22-2.043l2.555,1.523a1.19,1.19,0,0,1-.612,2.213Z'
            transform='translate(-649.434 -646.596)'
            fill='url(#linear-gradient-7)'
          />
          <path
            id='Path_14263'
            data-name='Path 14263'
            d='M1080.2,777.806c-.345,0-.686,0-1.024-.013a1.192,1.192,0,0,1-1.162-1.22,1.211,1.211,0,0,1,1.22-1.16,39.569,39.569,0,0,0,5.728-.274,1.191,1.191,0,0,1,.286,2.365A42.5,42.5,0,0,1,1080.2,777.806Zm-6.874-.58a1.436,1.436,0,0,1-.2-.015,42.627,42.627,0,0,1-5.9-1.445,1.191,1.191,0,1,1,.73-2.267,39.758,39.758,0,0,0,5.572,1.364,1.19,1.19,0,0,1-.2,2.364Zm17.577-.838a1.19,1.19,0,0,1-.307-2.34,39.889,39.889,0,0,0,5.415-1.888,1.19,1.19,0,1,1,.944,2.185,42.151,42.151,0,0,1-5.741,2A1.21,1.21,0,0,1,1090.906,776.388Zm-28.794-2.78a1.188,1.188,0,0,1-.522-.12q-.823-.405-1.634-.846l-3.625-1.959a1.19,1.19,0,1,1,1.132-2.095l3.629,1.961q.769.42,1.546.8a1.19,1.19,0,0,1-.525,2.258Zm39.616-1.886a1.19,1.19,0,0,1-.624-2.2c.183-.112.364-.225.546-.342l4.511-2.736a1.191,1.191,0,0,1,1.234,2.036l-4.486,2.719c-.169.108-.364.23-.561.351A1.193,1.193,0,0,1,1101.727,771.722Zm-50.034-3.706a1.18,1.18,0,0,1-.564-.143l-5.2-2.81a1.191,1.191,0,1,1,1.133-2.095l5.2,2.81a1.19,1.19,0,0,1-.568,2.237Zm60.139-2.434a1.19,1.19,0,0,1-.618-2.208l5.056-3.067a1.191,1.191,0,1,1,1.234,2.036l-5.056,3.067A1.2,1.2,0,0,1,1111.833,765.582Zm-70.542-3.188a1.188,1.188,0,0,1-.565-.143l-5.2-2.81a1.19,1.19,0,0,1,1.132-2.095l5.2,2.81a1.19,1.19,0,0,1-.568,2.237Zm80.652-2.943a1.191,1.191,0,0,1-.618-2.209l5.056-3.066a1.191,1.191,0,1,1,1.234,2.036l-5.056,3.066A1.187,1.187,0,0,1,1121.943,759.451Zm-91.055-2.677a1.185,1.185,0,0,1-.565-.143l-5.2-2.811a1.19,1.19,0,0,1,1.132-2.094l5.2,2.811a1.19,1.19,0,0,1-.566,2.238Zm101.166-3.457a1.19,1.19,0,0,1-.619-2.208l5.056-3.066a1.191,1.191,0,1,1,1.234,2.036l-5.056,3.066A1.2,1.2,0,0,1,1132.054,753.317Zm-111.569-2.165a1.18,1.18,0,0,1-.565-.143l-5.2-2.81a1.19,1.19,0,1,1,1.132-2.095l5.2,2.81a1.19,1.19,0,0,1-.567,2.237Zm121.681-3.967a1.19,1.19,0,0,1-.619-2.208l5.054-3.067a1.191,1.191,0,1,1,1.234,2.036l-5.054,3.066A1.187,1.187,0,0,1,1142.166,747.185Zm-132.085-1.654a1.178,1.178,0,0,1-.564-.143l-5.2-2.811a1.19,1.19,0,1,1,1.132-2.094l5.2,2.811a1.19,1.19,0,0,1-.568,2.237Zm142.195-4.477a1.191,1.191,0,0,1-.619-2.209l5.054-3.066a1.191,1.191,0,0,1,1.234,2.036l-5.054,3.064A1.175,1.175,0,0,1,1152.276,741.054Zm-152.6-1.144a1.188,1.188,0,0,1-.566-.143l-5.2-2.811a1.19,1.19,0,1,1,1.133-2.093l5.2,2.81a1.19,1.19,0,0,1-.567,2.237ZM742.414,737.7c-1.021,0-2.048-.049-3.053-.142a1.19,1.19,0,1,1,.218-2.371,30.856,30.856,0,0,0,5.685,0,1.2,1.2,0,0,1,1.295,1.075,1.191,1.191,0,0,1-1.075,1.3C744.465,737.653,743.432,737.7,742.414,737.7Zm-8.745-1.228a1.258,1.258,0,0,1-.329-.045,33.015,33.015,0,0,1-5.705-2.23,1.19,1.19,0,1,1,1.07-2.127A30.306,30.306,0,0,0,734,734.139a1.191,1.191,0,0,1-.327,2.335Zm17.5,0a1.19,1.19,0,0,1-.327-2.334,30.443,30.443,0,0,0,5.29-2.071,1.19,1.19,0,1,1,1.072,2.124,32.739,32.739,0,0,1-5.7,2.234A1.227,1.227,0,0,1,751.173,736.469Zm411.212-1.548a1.19,1.19,0,0,1-.619-2.208l5.054-3.064a1.19,1.19,0,1,1,1.235,2.035L1163,734.75A1.2,1.2,0,0,1,1162.386,734.921Zm-173.11-.632a1.188,1.188,0,0,1-.565-.143l-5.2-2.811a1.19,1.19,0,0,1,1.132-2.095l5.2,2.811a1.19,1.19,0,0,1-.567,2.237Zm-227.341-2.668a1.191,1.191,0,0,1-.543-2.251l5.264-2.691a1.19,1.19,0,1,1,1.083,2.12l-5.263,2.692A1.193,1.193,0,0,1,761.934,731.621Zm-38.884-.254a1.178,1.178,0,0,1-.608-.168l-5.078-3.028a1.19,1.19,0,1,1,1.219-2.045l5.077,3.029a1.189,1.189,0,0,1-.609,2.211Zm449.445-2.578a1.19,1.19,0,0,1-.618-2.208l5.054-3.067a1.191,1.191,0,0,1,1.234,2.036l-5.054,3.066A1.189,1.189,0,0,1,1172.5,728.789Zm-193.622-.122a1.18,1.18,0,0,1-.565-.143l-5.2-2.81a1.19,1.19,0,0,1,1.132-2.095l5.2,2.811a1.189,1.189,0,0,1-.567,2.236Zm-206.411-2.43a1.19,1.19,0,0,1-.543-2.249l5.264-2.693a1.19,1.19,0,1,1,1.083,2.12L773,726.107A1.188,1.188,0,0,1,772.462,726.237Zm-59.568-.926a1.187,1.187,0,0,1-.607-.167l-5.078-3.028a1.19,1.19,0,1,1,1.217-2.046L713.5,723.1a1.189,1.189,0,0,1-.611,2.211Zm255.575-2.265a1.177,1.177,0,0,1-.564-.143l-5.2-2.811A1.19,1.19,0,1,1,963.835,718l5.2,2.81a1.19,1.19,0,0,1-.568,2.237Zm214.136-.388a1.191,1.191,0,0,1-.618-2.209l5.054-3.066a1.19,1.19,0,1,1,1.234,2.035l-5.054,3.067A1.188,1.188,0,0,1,1182.606,722.658ZM782.99,720.853a1.19,1.19,0,0,1-.543-2.251l5.264-2.691a1.19,1.19,0,0,1,1.083,2.12l-5.264,2.692A1.192,1.192,0,0,1,782.99,720.853Zm-80.251-1.6a1.181,1.181,0,0,1-.608-.168l-5.078-3.029a1.189,1.189,0,1,1,1.217-2.044l5.079,3.029a1.189,1.189,0,0,1-.611,2.211Zm255.328-1.83a1.178,1.178,0,0,1-.564-.143l-5.2-2.81a1.19,1.19,0,1,1,1.132-2.095l5.2,2.81a1.19,1.19,0,0,1-.568,2.237Zm234.649-.9a1.19,1.19,0,0,1-.618-2.208l5.054-3.066a1.191,1.191,0,0,1,1.234,2.036l-5.054,3.066A1.2,1.2,0,0,1,1192.716,716.525Zm-399.2-1.056a1.191,1.191,0,0,1-.544-2.251l5.264-2.692a1.191,1.191,0,0,1,1.083,2.121l-5.263,2.691A1.19,1.19,0,0,1,793.519,715.47ZM692.582,713.2a1.2,1.2,0,0,1-.609-.168L686.9,710a1.19,1.19,0,0,1,1.22-2.043l5.078,3.029a1.19,1.19,0,0,1-.612,2.211ZM947.664,711.8a1.188,1.188,0,0,1-.565-.144l-5.2-2.81a1.191,1.191,0,0,1,1.132-2.095l5.2,2.811a1.191,1.191,0,0,1-.568,2.237Zm255.162-1.41a1.19,1.19,0,0,1-.618-2.209l5.056-3.066a1.191,1.191,0,1,1,1.234,2.036l-5.056,3.066A1.187,1.187,0,0,1,1202.826,710.394Zm-398.78-.308a1.19,1.19,0,0,1-.543-2.249l5.264-2.693a1.19,1.19,0,1,1,1.083,2.12l-5.264,2.693A1.186,1.186,0,0,1,804.046,710.086Zm-121.619-2.942a1.18,1.18,0,0,1-.608-.168l-5.078-3.029a1.19,1.19,0,0,1,1.219-2.045l5.077,3.028a1.191,1.191,0,0,1-.609,2.214Zm254.834-.961a1.2,1.2,0,0,1-.565-.143l-5.2-2.812a1.19,1.19,0,1,1,1.132-2.094l5.2,2.811a1.19,1.19,0,0,1-.567,2.237ZM814.573,704.7a1.19,1.19,0,0,1-.543-2.25l5.264-2.692a1.191,1.191,0,0,1,1.083,2.121l-5.264,2.691A1.175,1.175,0,0,1,814.573,704.7Zm398.364-.439a1.191,1.191,0,0,1-.619-2.209l5.056-3.066a1.191,1.191,0,0,1,1.234,2.036l-5.056,3.066A1.187,1.187,0,0,1,1212.937,704.262Zm-540.666-3.175a1.179,1.179,0,0,1-.608-.168l-5.079-3.028a1.191,1.191,0,0,1,1.219-2.046l5.078,3.028a1.191,1.191,0,0,1-.609,2.214Zm254.586-.526a1.181,1.181,0,0,1-.565-.143l-5.2-2.81a1.19,1.19,0,0,1,1.132-2.095l5.2,2.81a1.19,1.19,0,0,1-.566,2.237ZM825.1,699.317a1.19,1.19,0,0,1-.543-2.249l5.264-2.692a1.19,1.19,0,0,1,1.084,2.12l-5.265,2.692A1.191,1.191,0,0,1,825.1,699.317Zm397.946-1.188a1.19,1.19,0,0,1-.619-2.208l5.056-3.066a1.191,1.191,0,0,1,1.234,2.036l-5.056,3.066A1.2,1.2,0,0,1,1223.047,698.13Zm-560.933-3.1a1.178,1.178,0,0,1-.607-.168l-5.078-3.029a1.19,1.19,0,0,1,1.217-2.044l5.078,3.028a1.19,1.19,0,0,1-.611,2.214Zm254.34-.089a1.179,1.179,0,0,1-.564-.144l-5.2-2.811a1.19,1.19,0,1,1,1.132-2.095l5.2,2.812a1.19,1.19,0,0,1-.568,2.237Zm-80.825-1.007a1.191,1.191,0,0,1-.543-2.251l5.264-2.692a1.19,1.19,0,1,1,1.083,2.12l-5.264,2.693A1.186,1.186,0,0,1,835.629,693.934ZM1233.157,692a1.191,1.191,0,0,1-.619-2.209l5.056-3.066a1.191,1.191,0,1,1,1.234,2.036l-5.056,3.066A1.183,1.183,0,0,1,1233.157,692Zm-327.106-2.679a1.179,1.179,0,0,1-.564-.143l-5.2-2.81a1.191,1.191,0,1,1,1.133-2.095l5.2,2.81a1.19,1.19,0,0,1-.568,2.238Zm-59.894-.77a1.189,1.189,0,0,1-.543-2.249l5.264-2.692a1.19,1.19,0,1,1,1.083,2.12l-5.264,2.692A1.189,1.189,0,0,1,846.157,688.549Zm397.111-2.683a1.191,1.191,0,0,1-.619-2.209l5.056-3.066a1.191,1.191,0,0,1,1.235,2.036l-5.057,3.066A1.183,1.183,0,0,1,1243.268,685.866ZM895.648,683.7a1.187,1.187,0,0,1-.565-.143l-5.189-2.8a1.19,1.19,0,1,1,1.1-2.109l5.218,2.815a1.19,1.19,0,0,1-.568,2.237Zm-38.964-.532a1.19,1.19,0,0,1-.543-2.251l4.1-2.093c.38-.2.783-.411,1.191-.608a1.19,1.19,0,0,1,1.039,2.141c-.377.183-.753.375-1.125.575l-4.118,2.106A1.191,1.191,0,0,1,856.685,683.166Zm396.693-3.432a1.19,1.19,0,0,1-.619-2.208l5.057-3.066a1.19,1.19,0,1,1,1.234,2.036l-5.056,3.066A1.2,1.2,0,0,1,1253.378,679.734Zm-368.4-1.075a1.206,1.206,0,0,1-.345-.051,30.635,30.635,0,0,0-5.567-1.134,1.19,1.19,0,0,1,.256-2.366,32.888,32.888,0,0,1,6,1.222,1.19,1.19,0,0,1-.345,2.329Zm-17.505-.256a1.19,1.19,0,0,1-.311-2.339,33.106,33.106,0,0,1,6.035-1.048,1.191,1.191,0,0,1,.188,2.374,30.66,30.66,0,0,0-5.6.971A1.183,1.183,0,0,1,867.476,678.4Zm396.013-4.8a1.19,1.19,0,0,1-.617-2.208l5.054-3.067a1.19,1.19,0,1,1,1.234,2.036l-5.054,3.066A1.189,1.189,0,0,1,1263.489,673.6Zm10.11-6.132a1.19,1.19,0,0,1-.618-2.208l5.054-3.067a1.19,1.19,0,1,1,1.234,2.034l-5.054,3.067A1.178,1.178,0,0,1,1273.6,667.471Zm10.11-6.134a1.189,1.189,0,0,1-.618-2.206l5.054-3.067a1.19,1.19,0,1,1,1.234,2.036l-5.054,3.066A1.2,1.2,0,0,1,1283.709,661.337Z'
            transform='translate(-648.214 -651.257)'
            fill='url(#linear-gradient-8)'
          />
          <path
            id='Path_14264'
            data-name='Path 14264'
            d='M1192.129,655.918a1.19,1.19,0,0,1-.619-2.208l2.546-1.542a1.191,1.191,0,0,1,1.234,2.036l-2.546,1.542A1.186,1.186,0,0,1,1192.129,655.918Z'
            transform='translate(-546.481 -651.998)'
            fill='url(#linear-gradient-9)'
          />
        </g>
        <g id='Group_2864' data-name='Group 2864' transform='translate(727.717 423.603)'>
          <path
            id='Path_1540'
            data-name='Path 1540'
            d='M1247.035,621.433h0V545.7l-20.776.186-20.777-.186v75.735h0c-.534,3.353,1.547,6.808,6.248,9.374a31.912,31.912,0,0,0,13.9,3.407v.037c.211,0,.42-.014.63-.019s.419.017.629.019v-.037a31.912,31.912,0,0,0,13.9-3.407C1245.489,628.24,1247.571,624.785,1247.035,621.433Z'
            transform='translate(-1205.4 -534.285)'
            fill='#639'
          />
          <path
            id='Path_1541'
            data-name='Path 1541'
            d='M1240.794,539.5a31.56,31.56,0,0,0-13.926-3.368v-.029c-.208,0-.414.012-.621.014s-.413-.015-.62-.014v.029A31.566,31.566,0,0,0,1211.7,539.5c-8.3,4.533-8.3,11.885,0,16.417a31.55,31.55,0,0,0,13.927,3.368v.03c.207,0,.414-.012.62-.014s.413.014.621.014v-.03a31.548,31.548,0,0,0,13.926-3.368C1249.1,551.389,1249.1,544.038,1240.794,539.5Z'
            transform='translate(-1205.387 -536.108)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1542'
            data-name='Path 1542'
            d='M1222.4,567.574a32.58,32.58,0,0,0,15.227-3.394,15.015,15.015,0,0,0,6.178-6.23v1.52a16.869,16.869,0,0,1-5.8,5.321,30.765,30.765,0,0,1-11.77,3.33c-1.241.118-2.488.174-3.729.174h-.1Z'
            transform='translate(-1202.169 -531.955)'
            fill='#0fa'
          />
          <path
            id='Path_1543'
            data-name='Path 1543'
            d='M1222.4,575.586a32.594,32.594,0,0,0,15.227-3.4,15.008,15.008,0,0,0,6.178-6.23v1.52a16.86,16.86,0,0,1-5.8,5.322,30.81,30.81,0,0,1-11.77,3.33c-1.241.115-2.488.174-3.729.174h-.1Z'
            transform='translate(-1202.169 -530.433)'
            fill='#0fa'
          />
          <path
            id='Path_1544'
            data-name='Path 1544'
            d='M1222.4,583.6a32.6,32.6,0,0,0,15.227-3.4,15.024,15.024,0,0,0,6.178-6.23v1.52a16.855,16.855,0,0,1-5.8,5.321,30.763,30.763,0,0,1-11.77,3.33c-1.241.118-2.488.175-3.729.175h-.1Z'
            transform='translate(-1202.169 -528.91)'
            fill='#0fa'
          />
          <path
            id='Path_1545'
            data-name='Path 1545'
            d='M1222.4,591.607a32.58,32.58,0,0,0,15.227-3.4,15.009,15.009,0,0,0,6.178-6.23v1.52a16.873,16.873,0,0,1-5.8,5.322,30.806,30.806,0,0,1-11.77,3.33c-1.241.117-2.488.174-3.729.174h-.1Z'
            transform='translate(-1202.169 -527.387)'
            fill='#0fa'
          />
          <path
            id='Path_1546'
            data-name='Path 1546'
            d='M1222.4,599.618a32.6,32.6,0,0,0,15.227-3.4,15.013,15.013,0,0,0,6.178-6.229v1.519a16.845,16.845,0,0,1-5.8,5.321,30.785,30.785,0,0,1-11.77,3.331c-1.241.117-2.488.174-3.729.174h-.1Z'
            transform='translate(-1202.169 -525.864)'
            fill='#0fa'
          />
          <path
            id='Path_1547'
            data-name='Path 1547'
            d='M1222.4,607.628a32.6,32.6,0,0,0,15.227-3.4A15.009,15.009,0,0,0,1243.8,598v1.52a16.862,16.862,0,0,1-5.8,5.322,30.809,30.809,0,0,1-11.77,3.33c-1.241.117-2.488.174-3.729.174h-.1Z'
            transform='translate(-1202.169 -524.341)'
            fill='#0fa'
          />
          <path
            id='Path_1548'
            data-name='Path 1548'
            d='M1222.4,615.638a32.565,32.565,0,0,0,15.227-3.4,15.013,15.013,0,0,0,6.178-6.229v1.52a16.868,16.868,0,0,1-5.8,5.321,30.785,30.785,0,0,1-11.77,3.33c-1.241.118-2.488.175-3.729.175h-.1Z'
            transform='translate(-1202.169 -522.818)'
            fill='#0fa'
          />
        </g>
        <g id='Group_2865' data-name='Group 2865' transform='translate(746.614 463.072)'>
          <path
            id='Path_1549'
            data-name='Path 1549'
            d='M1266.829,662.623h0V579.764l-22.73.2-22.73-.2V662.62h0c-.585,3.668,1.691,7.448,6.835,10.254a34.91,34.91,0,0,0,15.206,3.73v.038c.23,0,.461-.014.689-.019s.458.019.689.019V676.6a34.905,34.905,0,0,0,15.205-3.73C1265.137,670.069,1267.414,666.291,1266.829,662.623Z'
            transform='translate(-1221.279 -567.277)'
            fill='url(#linear-gradient-10)'
          />
          <path
            id='Path_1550'
            data-name='Path 1550'
            d='M1260,572.988a34.534,34.534,0,0,0-15.237-3.686v-.03c-.227,0-.452.013-.678.014s-.452-.016-.678-.014v.03a34.531,34.531,0,0,0-15.237,3.686c-9.087,4.959-9.087,13,0,17.96a34.5,34.5,0,0,0,15.237,3.685v.032c.226,0,.452-.013.678-.015s.451.017.678.015v-.032A34.516,34.516,0,0,0,1260,590.948C1269.086,585.988,1269.086,577.947,1260,572.988Z'
            transform='translate(-1221.264 -569.272)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1551'
            data-name='Path 1551'
            d='M1239.873,603.7c6.123.013,12.177-1.269,16.661-3.716a16.443,16.443,0,0,0,6.759-6.816v1.663a18.44,18.44,0,0,1-6.351,5.821,33.653,33.653,0,0,1-12.877,3.644c-1.358.128-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -564.729)'
            fill='#0fa'
          />
          <path
            id='Path_1552'
            data-name='Path 1552'
            d='M1239.873,612.462c6.123.014,12.177-1.27,16.661-3.717a16.43,16.43,0,0,0,6.759-6.816v1.664a18.431,18.431,0,0,1-6.351,5.821,33.7,33.7,0,0,1-12.877,3.644c-1.358.128-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -563.063)'
            fill='#0fa'
          />
          <path
            id='Path_1553'
            data-name='Path 1553'
            d='M1239.873,621.227c6.123.014,12.177-1.27,16.661-3.717a16.439,16.439,0,0,0,6.759-6.817v1.663a18.444,18.444,0,0,1-6.351,5.822,33.652,33.652,0,0,1-12.877,3.644c-1.358.129-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -561.397)'
            fill='#0fa'
          />
          <path
            id='Path_1554'
            data-name='Path 1554'
            d='M1239.873,629.991c6.123.014,12.177-1.271,16.661-3.718a16.43,16.43,0,0,0,6.759-6.816v1.664a18.465,18.465,0,0,1-6.351,5.821,33.693,33.693,0,0,1-12.877,3.644c-1.358.129-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -559.73)'
            fill='#0fa'
          />
          <path
            id='Path_1555'
            data-name='Path 1555'
            d='M1239.873,638.755c6.123.014,12.177-1.27,16.661-3.717a16.436,16.436,0,0,0,6.759-6.816v1.663a18.443,18.443,0,0,1-6.351,5.822,33.652,33.652,0,0,1-12.877,3.644c-1.358.126-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -558.064)'
            fill='#0fa'
          />
          <path
            id='Path_1556'
            data-name='Path 1556'
            d='M1239.873,647.519c6.123.014,12.177-1.271,16.661-3.717a16.439,16.439,0,0,0,6.759-6.817v1.664a18.439,18.439,0,0,1-6.351,5.821,33.7,33.7,0,0,1-12.877,3.644c-1.358.128-2.722.19-4.08.19h-.112Z'
            transform='translate(-1217.743 -556.398)'
            fill='#0fa'
          />
          <path
            id='Path_1557'
            data-name='Path 1557'
            d='M1239.873,656.284c6.123.013,12.177-1.271,16.661-3.718a16.437,16.437,0,0,0,6.759-6.816v1.661a18.459,18.459,0,0,1-6.351,5.823,33.694,33.694,0,0,1-12.877,3.644c-1.358.126-2.722.189-4.08.189h-.112Z'
            transform='translate(-1217.743 -554.732)'
            fill='#0fa'
          />
        </g>
        <g id='Group_2894' data-name='Group 2894' transform='translate(686.552 439.428)'>
          <path
            id='Path_1666'
            data-name='Path 1666'
            d='M1232.084,674.973h0V563.517l-30.578.277-30.574-.277V674.972h0c-.789,4.935,2.278,10.018,9.194,13.795a46.982,46.982,0,0,0,20.453,5.015v.054c.311,0,.619-.021.926-.027s.619.026.929.027v-.054a46.98,46.98,0,0,0,20.453-5.015C1229.808,684.992,1232.873,679.91,1232.084,674.973Z'
            transform='translate(-1170.811 -546.722)'
            fill='#639'
          />
          <path
            id='Path_1667'
            data-name='Path 1667'
            d='M1222.9,554.4a46.43,46.43,0,0,0-20.5-4.957v-.042c-.3,0-.609.017-.913.02s-.608-.021-.912-.02v.042a46.429,46.429,0,0,0-20.5,4.957c-12.226,6.671-12.226,17.489,0,24.16a46.429,46.429,0,0,0,20.5,4.957v.043c.3,0,.609-.017.912-.022s.608.022.913.022v-.043a46.43,46.43,0,0,0,20.5-4.957C1235.123,571.892,1235.123,561.074,1222.9,554.4Z'
            transform='translate(-1170.793 -549.405)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1668'
            data-name='Path 1668'
            d='M1195.827,595.71c8.235.018,16.379-1.705,22.416-4.995a22.114,22.114,0,0,0,9.091-9.168v2.236a24.825,24.825,0,0,1-8.542,7.83,45.336,45.336,0,0,1-17.322,4.9c-1.827.171-3.661.256-5.485.256h-.153Z'
            transform='translate(-1166.055 -543.294)'
            fill='#0fa'
          />
          <path
            id='Path_1669'
            data-name='Path 1669'
            d='M1195.827,607.5c8.237.018,16.379-1.708,22.416-5a22.129,22.129,0,0,0,9.091-9.17v2.236a24.833,24.833,0,0,1-8.542,7.832,45.336,45.336,0,0,1-17.322,4.9c-1.827.17-3.661.256-5.485.256h-.153Z'
            transform='translate(-1166.055 -541.053)'
            fill='#0fa'
          />
          <path
            id='Path_1670'
            data-name='Path 1670'
            d='M1195.827,619.291c8.237.018,16.379-1.709,22.416-5a22.1,22.1,0,0,0,9.091-9.168v2.237a24.835,24.835,0,0,1-8.542,7.83,45.339,45.339,0,0,1-17.322,4.9c-1.827.17-3.661.256-5.485.256h-.153Z'
            transform='translate(-1166.055 -538.812)'
            fill='#0fa'
          />
          <path
            id='Path_1671'
            data-name='Path 1671'
            d='M1195.827,631.081c8.237.019,16.379-1.711,22.416-5a22.1,22.1,0,0,0,9.091-9.168v2.237a24.833,24.833,0,0,1-8.542,7.832,45.336,45.336,0,0,1-17.322,4.9c-1.827.17-3.661.256-5.485.256h-.153Z'
            transform='translate(-1166.055 -536.57)'
            fill='#0fa'
          />
          <path
            id='Path_1672'
            data-name='Path 1672'
            d='M1195.827,642.869c8.237.02,16.379-1.71,22.416-5a22.116,22.116,0,0,0,9.091-9.167v2.236a24.824,24.824,0,0,1-8.542,7.83,45.314,45.314,0,0,1-17.322,4.9c-1.827.17-3.661.255-5.485.255h-.153Z'
            transform='translate(-1166.055 -534.329)'
            fill='#0fa'
          />
          <path
            id='Path_1673'
            data-name='Path 1673'
            d='M1195.827,654.654c8.237.018,16.379-1.709,22.416-5a22.1,22.1,0,0,0,9.091-9.168v2.236a24.831,24.831,0,0,1-8.542,7.832,45.337,45.337,0,0,1-17.322,4.9c-1.827.173-3.661.255-5.485.255h-.153Z'
            transform='translate(-1166.055 -532.088)'
            fill='#0fa'
          />
          <path
            id='Path_1674'
            data-name='Path 1674'
            d='M1195.827,666.446c8.237.02,16.379-1.709,22.416-5a22.1,22.1,0,0,0,9.091-9.167v2.237a24.854,24.854,0,0,1-8.542,7.832,45.337,45.337,0,0,1-17.322,4.9c-1.827.17-3.661.256-5.485.256h-.153Z'
            transform='translate(-1166.055 -529.846)'
            fill='#0fa'
          />
        </g>
        <g id='Group_2902' data-name='Group 2902' transform='translate(45.553 429.184)'>
          <g id='Group_2896' data-name='Group 2896' transform='translate(0 27.088)'>
            <path
              id='Path_1676'
              data-name='Path 1676'
              d='M628.983,629.5l5.457-2.978V561.572l-5.457,2.979Z'
              transform='translate(-623.525 -561.567)'
              fill='#361a47'
            />
            <path
              id='Path_1677'
              data-name='Path 1677'
              d='M629.856,629.5l-5.459-2.984V561.568l5.459,2.981Z'
              transform='translate(-624.397 -561.568)'
              fill='#361a47'
            />
          </g>
          <path
            id='Path_1678'
            data-name='Path 1678'
            d='M628.983,633.281l50.4-26.626V541.7l-50.4,26.628Z'
            transform='translate(-623.525 -538.257)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1679'
            data-name='Path 1679'
            d='M629.856,629.5,624.4,626.52V561.567l5.459,2.981Z'
            transform='translate(-624.397 -534.48)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
          <path
            id='Path_1680'
            data-name='Path 1680'
            d='M741.638,649.811l-75.8-40.25V544.608l75.8,40.252Z'
            transform='translate(-609.985 -537.704)'
            fill='#639'
          />
          <path
            id='Path_1681'
            data-name='Path 1681'
            d='M636.908,585.052l18.1-9.877v-1.538l-18.1,9.877Z'
            transform='translate(-622.018 -532.185)'
            fill='#fff2fa'
          />
          <path
            id='Path_1682'
            data-name='Path 1682'
            d='M636.908,589.847l18.1-9.877v-1.536l-18.1,9.877Z'
            transform='translate(-622.018 -531.273)'
            fill='#fff2fa'
          />
          <path
            id='Path_1683'
            data-name='Path 1683'
            d='M636.908,594.1l18.1-9.878v-1.537l-18.1,9.877Z'
            transform='translate(-622.018 -530.464)'
            fill='#fff2fa'
          />
          <g id='Group_2897' data-name='Group 2897' transform='translate(54.64 65.327)'>
            <path
              id='Path_1684'
              data-name='Path 1684'
              d='M670.31,597.516,733.8,632.16l7-3.818L677.305,593.7Z'
              transform='translate(-670.307 -593.698)'
              fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
            />
            <path
              id='Path_1685'
              data-name='Path 1685'
              d='M730.65,625.295V622.81l-6.994,3.818v2.484Z'
              transform='translate(-660.165 -588.163)'
              fill='#639'
            />
            <path
              id='Path_1686'
              data-name='Path 1686'
              d='M733.8,634.036l-63.491-34.643v-2.485L733.8,631.552Z'
              transform='translate(-670.308 -593.088)'
              fill='#639'
            />
          </g>
          <g id='Group_2899' data-name='Group 2899' transform='translate(125.25 47.16)'>
            <path
              id='Path_1689'
              data-name='Path 1689'
              d='M734.11,646.369l5.457-2.979V578.433l-5.457,2.978Z'
              transform='translate(-728.654 -578.433)'
              fill='#0fa'
            />
            <path
              id='Path_1690'
              data-name='Path 1690'
              d='M734.987,646.369l-5.457-2.979V578.433l5.457,2.978Z'
              transform='translate(-729.53 -578.433)'
              fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
            />
          </g>
          <g id='Group_2901' data-name='Group 2901' transform='translate(80.946 71.175)'>
            <path
              id='Path_1693'
              data-name='Path 1693'
              d='M697,666.544l5.455-2.979V598.612L697,601.586Z'
              transform='translate(-691.54 -598.612)'
              fill='#0fa'
            />
            <path
              id='Path_1694'
              data-name='Path 1694'
              d='M697.87,666.544l-5.458-2.979V598.612l5.458,2.979Z'
              transform='translate(-692.412 -598.612)'
              fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
            />
          </g>
          <path
            id='Path_1695'
            data-name='Path 1695'
            d='M624.409,565.9,710.8,613.05l49.628-27.093-86.389-47.15Z'
            transform='translate(-624.395 -538.807)'
            fill='url(#linear-gradient-11)'
          />
          <path
            id='Path_1696'
            data-name='Path 1696'
            d='M746.629,577.433v8.727L697,613.248v-8.734Z'
            transform='translate(-610.936 -531.203)'
            fill='#0fa'
          />
          <path
            id='Path_1697'
            data-name='Path 1697'
            d='M710.8,616.523v-7.8l-86.389-47.15v7.807Z'
            transform='translate(-624.394 -535.409)'
            fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
          />
        </g>
        <g id='Group_2966' data-name='Group 2966' transform='translate(948.791 317.938)'>
          <g id='Group_2958' data-name='Group 2958'>
            <g id='Group_2957' data-name='Group 2957'>
              <g id='Group_2954' data-name='Group 2954' transform='translate(27.281 138.487)'>
                <path
                  id='Path_1878'
                  data-name='Path 1878'
                  d='M1433.048,570.45v-1.857h-.386a7.791,7.791,0,0,0-3.533-3.416,22.016,22.016,0,0,0-18.942,0,7.769,7.769,0,0,0-3.532,3.416h-.389v1.879h0c.057,1.828,1.362,3.644,3.919,5.04a22.016,22.016,0,0,0,18.942,0c2.526-1.377,3.829-3.168,3.915-4.975h0Z'
                  transform='translate(-1406.265 -561.442)'
                  fill='#283568'
                />
                <ellipse
                  id='Ellipse_1539'
                  data-name='Ellipse 1539'
                  cx='13.393'
                  cy='7.309'
                  rx='13.393'
                  ry='7.309'
                  fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
                />
              </g>
              <g id='Group_2955' data-name='Group 2955' transform='translate(35.638 138.262)'>
                <path
                  id='Path_1879'
                  data-name='Path 1879'
                  d='M1423.357,570.1v-6.071h-.146a2.909,2.909,0,0,0-1.327-1.285,8.277,8.277,0,0,0-7.122,0,2.917,2.917,0,0,0-1.328,1.285h-.146v6.08h0A2.409,2.409,0,0,0,1414.76,572a8.285,8.285,0,0,0,7.121,0,2.422,2.422,0,0,0,1.472-1.871h0Z'
                  transform='translate(-1413.287 -561.426)'
                  fill='#283568'
                />
                <ellipse
                  id='Ellipse_1540'
                  data-name='Ellipse 1540'
                  cx='5.035'
                  cy='2.748'
                  rx='5.035'
                  ry='2.748'
                  transform='translate(0)'
                  fill='#0fa'
                />
              </g>
              <path
                id='Path_1880'
                data-name='Path 1880'
                d='M1415.522,459.359l-1.034,123.009h0a1.767,1.767,0,0,0,1.052,1.29,5.916,5.916,0,0,0,5.1,0,1.767,1.767,0,0,0,1.052-1.29h0l-1.034-123.009Z'
                transform='translate(-1377.42 -442.666)'
                fill='#283568'
              />
              <path
                id='Path_1881'
                data-name='Path 1881'
                d='M1390.453,449.316l33.026,17.976-2.365,1.283-33-18.012Z'
                transform='translate(-1382.435 -444.576)'
                fill='#283568'
              />
              <g id='Group_2956' data-name='Group 2956'>
                <path
                  id='Path_1882'
                  data-name='Path 1882'
                  d='M1395.7,450.292l-5.115-2.792a2.9,2.9,0,0,0-2.483,0l-2.261,1.238-2.495-.394V450.5a.824.824,0,0,0,.514.678l8.873,4.844a2.892,2.892,0,0,0,2.484,0l4.241-2.315a.824.824,0,0,0,.512-.678v-2.055Z'
                  transform='translate(-1383.342 -444.974)'
                  fill='#283568'
                />
                <path
                  id='Path_1883'
                  data-name='Path 1883'
                  d='M1399.482,451.819l-4.241,2.315a2.891,2.891,0,0,1-2.484,0l-8.874-4.844c-.684-.371-.684-.99,0-1.361l4.242-2.317a2.906,2.906,0,0,1,2.483,0l8.875,4.844C1400.166,450.836,1400.166,451.445,1399.482,451.819Z'
                  transform='translate(-1383.337 -445.333)'
                  fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
                />
              </g>
            </g>
          </g>
          <g id='Group_2965' data-name='Group 2965' transform='translate(25.924 2.389)'>
            <path
              id='Path_1884'
              data-name='Path 1884'
              d='M1434.136,461.423l-3.689-13.069.619-.263-1.131-.619-.056-.032h-.008a.979.979,0,0,0-.894.018l-23.386,12.759a.865.865,0,0,0-.438.989l3.793,13.436a.888.888,0,0,0,.444.541h0l1.175.648-.136-.713,23.272-12.7A.866.866,0,0,0,1434.136,461.423Z'
              transform='translate(-1405.125 -447.341)'
              fill='#0fa'
            />
            <path
              id='Path_1885'
              data-name='Path 1885'
              d='M1434.708,462.973l-23.386,12.761a.952.952,0,0,1-1.295-.369.964.964,0,0,1-.074-.17l-3.794-13.437a.864.864,0,0,1,.437-.989l23.386-12.759a.949.949,0,0,1,1.293.362.874.874,0,0,1,.077.176'
              transform='translate(-1404.933 -447.237)'
              fill='#f7f7ff'
            />
            <g id='Group_2964' data-name='Group 2964' transform='translate(2.321 2.005)'>
              <g id='Group_2959' data-name='Group 2959'>
                <path
                  id='Path_1886'
                  data-name='Path 1886'
                  d='M1409.358,460.658l-1.621.878a.125.125,0,0,1-.168-.051l-.007-.019-.484-1.707a.111.111,0,0,1,.057-.124l1.62-.881a.125.125,0,0,1,.168.049l.009.021.484,1.708A.112.112,0,0,1,1409.358,460.658Z'
                  transform='translate(-1407.075 -447.179)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1887'
                  data-name='Path 1887'
                  d='M1411.574,459.435l-1.621.877a.125.125,0,0,1-.169-.048l-.01-.021-.482-1.709a.115.115,0,0,1,.055-.124l1.62-.877a.123.123,0,0,1,.169.046l.01.023.484,1.708A.116.116,0,0,1,1411.574,459.435Z'
                  transform='translate(-1406.654 -447.411)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1888'
                  data-name='Path 1888'
                  d='M1413.867,458.206l-1.618.877a.125.125,0,0,1-.169-.048l-.01-.021-.484-1.708a.112.112,0,0,1,.057-.124l1.62-.88a.124.124,0,0,1,.169.046l.009.023.482,1.709A.111.111,0,0,1,1413.867,458.206Z'
                  transform='translate(-1406.218 -447.645)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1889'
                  data-name='Path 1889'
                  d='M1416.046,457.025l-1.621.877a.125.125,0,0,1-.169-.048l-.01-.023-.484-1.707a.111.111,0,0,1,.057-.124l1.62-.88a.123.123,0,0,1,.169.046l.01.023.482,1.709A.112.112,0,0,1,1416.046,457.025Z'
                  transform='translate(-1405.804 -447.87)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1890'
                  data-name='Path 1890'
                  d='M1418.241,455.808l-1.621.877a.123.123,0,0,1-.168-.046l-.01-.023-.483-1.708a.11.11,0,0,1,.056-.124l1.62-.879a.125.125,0,0,1,.169.048l.01.021.483,1.709A.112.112,0,0,1,1418.241,455.808Z'
                  transform='translate(-1405.386 -448.101)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1891'
                  data-name='Path 1891'
                  d='M1420.449,454.587l-1.621.877a.126.126,0,0,1-.169-.049l-.008-.021-.484-1.708a.113.113,0,0,1,.057-.124l1.621-.877a.123.123,0,0,1,.169.046l.009.023.483,1.709A.116.116,0,0,1,1420.449,454.587Z'
                  transform='translate(-1404.967 -448.333)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1892'
                  data-name='Path 1892'
                  d='M1422.7,453.4l-1.619.878a.125.125,0,0,1-.169-.048l-.01-.023-.483-1.709a.112.112,0,0,1,.056-.123l1.621-.878a.125.125,0,0,1,.169.048l.009.023.483,1.708A.112.112,0,0,1,1422.7,453.4Z'
                  transform='translate(-1404.538 -448.558)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1893'
                  data-name='Path 1893'
                  d='M1424.894,452.181l-1.621.877a.123.123,0,0,1-.168-.048l-.01-.021-.484-1.708a.114.114,0,0,1,.057-.124l1.621-.88a.123.123,0,0,1,.169.046l.01.023.482,1.709A.11.11,0,0,1,1424.894,452.181Z'
                  transform='translate(-1404.121 -448.791)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1894'
                  data-name='Path 1894'
                  d='M1427.149,450.942l-1.621.878a.123.123,0,0,1-.168-.048l-.01-.023-.484-1.708a.115.115,0,0,1,.057-.124l1.621-.878a.125.125,0,0,1,.168.05l.01.021.482,1.707A.111.111,0,0,1,1427.149,450.942Z'
                  transform='translate(-1403.693 -449.026)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2960' data-name='Group 2960' transform='translate(0.746 2.646)'>
                <path
                  id='Path_1895'
                  data-name='Path 1895'
                  d='M1409.985,462.877l-1.619.877a.123.123,0,0,1-.168-.046l-.01-.021-.484-1.709a.112.112,0,0,1,.057-.124l1.621-.877a.125.125,0,0,1,.169.046l.01.021.482,1.709A.11.11,0,0,1,1409.985,462.877Z'
                  transform='translate(-1407.702 -449.402)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1896'
                  data-name='Path 1896'
                  d='M1412.2,461.652l-1.621.877a.124.124,0,0,1-.168-.051l-.008-.019-.484-1.709a.116.116,0,0,1,.057-.124l1.621-.877a.124.124,0,0,1,.168.051l.008.018.484,1.709A.114.114,0,0,1,1412.2,461.652Z'
                  transform='translate(-1407.281 -449.635)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1897'
                  data-name='Path 1897'
                  d='M1414.491,460.425l-1.62.878a.123.123,0,0,1-.168-.048l-.01-.021-.484-1.708a.114.114,0,0,1,.057-.124l1.621-.878a.125.125,0,0,1,.169.048l.01.021.482,1.708A.11.11,0,0,1,1414.491,460.425Z'
                  transform='translate(-1406.845 -449.868)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1898'
                  data-name='Path 1898'
                  d='M1416.669,459.242l-1.621.877a.122.122,0,0,1-.168-.046l-.01-.021-.484-1.709a.113.113,0,0,1,.057-.124l1.621-.877a.123.123,0,0,1,.168.049l.01.019.482,1.709A.11.11,0,0,1,1416.669,459.242Z'
                  transform='translate(-1406.432 -450.093)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1899'
                  data-name='Path 1899'
                  d='M1418.865,458.026l-1.621.877a.124.124,0,0,1-.169-.046l-.01-.021-.482-1.709a.113.113,0,0,1,.056-.124l1.621-.877a.124.124,0,0,1,.169.046l.01.021.483,1.709A.112.112,0,0,1,1418.865,458.026Z'
                  transform='translate(-1406.014 -450.325)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1900'
                  data-name='Path 1900'
                  d='M1421.073,456.8l-1.62.877a.124.124,0,0,1-.169-.046l-.01-.023-.483-1.708a.112.112,0,0,1,.056-.124l1.621-.878a.125.125,0,0,1,.169.048l.009.021.484,1.709A.113.113,0,0,1,1421.073,456.8Z'
                  transform='translate(-1405.594 -450.557)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1901'
                  data-name='Path 1901'
                  d='M1423.322,455.622l-1.621.877a.123.123,0,0,1-.168-.046l-.01-.023-.484-1.708a.115.115,0,0,1,.057-.13l1.62-.877a.122.122,0,0,1,.168.048l.011.021.482,1.709A.112.112,0,0,1,1423.322,455.622Z'
                  transform='translate(-1405.167 -450.783)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1902'
                  data-name='Path 1902'
                  d='M1425.519,454.4l-1.62.878a.123.123,0,0,1-.168-.048l-.01-.021-.483-1.708a.109.109,0,0,1,.056-.124l1.621-.878a.125.125,0,0,1,.168.049l.009.02.482,1.708A.109.109,0,0,1,1425.519,454.4Z'
                  transform='translate(-1404.749 -451.014)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1903'
                  data-name='Path 1903'
                  d='M1427.773,453.166l-1.62.877a.122.122,0,0,1-.168-.046l-.009-.023-.483-1.709a.112.112,0,0,1,.056-.124l1.621-.877a.125.125,0,0,1,.169.048l.009.023.482,1.708A.112.112,0,0,1,1427.773,453.166Z'
                  transform='translate(-1404.32 -451.249)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2961' data-name='Group 2961' transform='translate(1.498 5.289)'>
                <path
                  id='Path_1904'
                  data-name='Path 1904'
                  d='M1410.619,465.1l-1.622.877a.122.122,0,0,1-.168-.046l-.01-.021-.483-1.709a.113.113,0,0,1,.057-.124l1.619-.877a.123.123,0,0,1,.168.049l.01.019.483,1.709A.112.112,0,0,1,1410.619,465.1Z'
                  transform='translate(-1408.334 -451.622)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1905'
                  data-name='Path 1905'
                  d='M1412.834,463.878l-1.621.877a.123.123,0,0,1-.168-.048l-.011-.023-.482-1.709a.112.112,0,0,1,.056-.124l1.621-.877a.124.124,0,0,1,.168.048l.009.021.484,1.709A.113.113,0,0,1,1412.834,463.878Z'
                  transform='translate(-1407.912 -451.856)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1906'
                  data-name='Path 1906'
                  d='M1415.127,462.651l-1.622.878a.123.123,0,0,1-.167-.05l-.008-.019-.484-1.708a.111.111,0,0,1,.057-.124l1.62-.878a.124.124,0,0,1,.168.05l.008.019.483,1.708A.11.11,0,0,1,1415.127,462.651Z'
                  transform='translate(-1407.477 -452.088)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1907'
                  data-name='Path 1907'
                  d='M1417.3,461.468l-1.621.877a.124.124,0,0,1-.168-.05l-.008-.019-.484-1.708a.111.111,0,0,1,.057-.124l1.621-.877a.124.124,0,0,1,.168.05l.009.018.484,1.709A.114.114,0,0,1,1417.3,461.468Z'
                  transform='translate(-1407.062 -452.313)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1908'
                  data-name='Path 1908'
                  d='M1419.5,460.252l-1.62.877a.124.124,0,0,1-.169-.046l-.01-.021-.483-1.709a.112.112,0,0,1,.056-.124l1.621-.877a.124.124,0,0,1,.169.046l.01.021.483,1.709A.113.113,0,0,1,1419.5,460.252Z'
                  transform='translate(-1406.645 -452.545)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1909'
                  data-name='Path 1909'
                  d='M1421.708,459.034l-1.619.877a.123.123,0,0,1-.169-.046l-.01-.023-.483-1.708a.109.109,0,0,1,.056-.123l1.62-.881a.125.125,0,0,1,.168.051l.009.02.483,1.708A.111.111,0,0,1,1421.708,459.034Z'
                  transform='translate(-1406.225 -452.776)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1910'
                  data-name='Path 1910'
                  d='M1423.962,457.849l-1.62.877a.123.123,0,0,1-.168-.049l-.009-.02-.483-1.708a.112.112,0,0,1,.057-.13l1.62-.877a.123.123,0,0,1,.167.05l.008.019.484,1.709A.114.114,0,0,1,1423.962,457.849Z'
                  transform='translate(-1405.797 -453.002)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1911'
                  data-name='Path 1911'
                  d='M1426.155,456.624l-1.62.878a.125.125,0,0,1-.169-.048l-.01-.021-.484-1.708a.111.111,0,0,1,.057-.124l1.621-.878a.124.124,0,0,1,.169.048l.01.021.483,1.708A.113.113,0,0,1,1426.155,456.624Z'
                  transform='translate(-1405.38 -453.234)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1912'
                  data-name='Path 1912'
                  d='M1428.41,455.387l-1.62.877a.124.124,0,0,1-.169-.046l-.01-.023-.484-1.709a.114.114,0,0,1,.057-.124l1.62-.877a.125.125,0,0,1,.169.048l.009.021.482,1.709A.114.114,0,0,1,1428.41,455.387Z'
                  transform='translate(-1404.951 -453.47)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2962' data-name='Group 2962' transform='translate(2.258 7.969)'>
                <path
                  id='Path_1913'
                  data-name='Path 1913'
                  d='M1411.256,467.355l-1.621.877a.125.125,0,0,1-.169-.048l-.009-.021-.482-1.709a.115.115,0,0,1,.055-.124l1.621-.877a.124.124,0,0,1,.169.048l.01.023.484,1.709A.114.114,0,0,1,1411.256,467.355Z'
                  transform='translate(-1408.972 -453.874)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1914'
                  data-name='Path 1914'
                  d='M1413.47,466.127l-1.62.877a.122.122,0,0,1-.168-.046l-.01-.021-.483-1.709a.11.11,0,0,1,.056-.124l1.621-.877a.124.124,0,0,1,.169.046l.01.021.482,1.709A.109.109,0,0,1,1413.47,466.127Z'
                  transform='translate(-1408.55 -454.108)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1915'
                  data-name='Path 1915'
                  d='M1415.764,464.9l-1.62.877a.122.122,0,0,1-.168-.049l-.009-.02-.483-1.709a.113.113,0,0,1,.057-.124l1.619-.877a.123.123,0,0,1,.168.048l.01.024.484,1.708A.113.113,0,0,1,1415.764,464.9Z'
                  transform='translate(-1408.115 -454.341)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1916'
                  data-name='Path 1916'
                  d='M1417.941,463.72l-1.621.877a.124.124,0,0,1-.168-.05l-.008-.019-.483-1.709a.112.112,0,0,1,.057-.124l1.621-.877a.123.123,0,0,1,.167.051l.008.018L1418,463.6A.113.113,0,0,1,1417.941,463.72Z'
                  transform='translate(-1407.701 -454.565)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1917'
                  data-name='Path 1917'
                  d='M1420.139,462.5l-1.62.877a.125.125,0,0,1-.169-.048l-.009-.021-.482-1.709a.111.111,0,0,1,.056-.124l1.619-.877a.124.124,0,0,1,.169.046l.01.023.483,1.71A.112.112,0,0,1,1420.139,462.5Z'
                  transform='translate(-1407.283 -454.797)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1918'
                  data-name='Path 1918'
                  d='M1422.344,461.28l-1.62.88a.125.125,0,0,1-.168-.05l-.007-.019-.484-1.709a.113.113,0,0,1,.057-.124l1.62-.877a.124.124,0,0,1,.168.051l.007.018.484,1.708A.113.113,0,0,1,1422.344,461.28Z'
                  transform='translate(-1406.863 -455.029)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1919'
                  data-name='Path 1919'
                  d='M1424.6,460.1l-1.621.877a.123.123,0,0,1-.168-.05l-.007-.018-.484-1.709a.113.113,0,0,1,.057-.124l1.619-.877a.123.123,0,0,1,.168.048l.01.021.483,1.708A.111.111,0,0,1,1424.6,460.1Z'
                  transform='translate(-1406.435 -455.253)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1920'
                  data-name='Path 1920'
                  d='M1426.789,458.875l-1.619.877a.123.123,0,0,1-.169-.046l-.01-.023-.483-1.709a.111.111,0,0,1,.056-.124l1.621-.877a.124.124,0,0,1,.168.051l.008.018.485,1.709A.113.113,0,0,1,1426.789,458.875Z'
                  transform='translate(-1406.018 -455.486)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1921'
                  data-name='Path 1921'
                  d='M1429.046,457.637l-1.618.877a.125.125,0,0,1-.169-.046l-.01-.021-.483-1.709a.111.111,0,0,1,.057-.124l1.621-.877a.125.125,0,0,1,.168.05l.007.018.484,1.709A.112.112,0,0,1,1429.046,457.637Z'
                  transform='translate(-1405.589 -455.722)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2963' data-name='Group 2963' transform='translate(3.023 10.602)'>
                <path
                  id='Path_1922'
                  data-name='Path 1922'
                  d='M1411.9,469.569l-1.62.878a.123.123,0,0,1-.168-.048l-.01-.021-.484-1.708a.114.114,0,0,1,.057-.124l1.62-.877a.123.123,0,0,1,.169.046l.01.021.482,1.709A.109.109,0,0,1,1411.9,469.569Z'
                  transform='translate(-1409.615 -456.086)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1923'
                  data-name='Path 1923'
                  d='M1414.119,468.341l-1.621.877a.125.125,0,0,1-.169-.048l-.009-.023-.483-1.708a.111.111,0,0,1,.057-.124l1.62-.877a.122.122,0,0,1,.168.046l.01.023.483,1.708A.116.116,0,0,1,1414.119,468.341Z'
                  transform='translate(-1409.193 -456.32)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1924'
                  data-name='Path 1924'
                  d='M1416.408,467.115l-1.621.877a.123.123,0,0,1-.168-.046l-.01-.021-.483-1.709a.11.11,0,0,1,.056-.124l1.62-.877a.125.125,0,0,1,.169.046l.009.021.482,1.709A.109.109,0,0,1,1416.408,467.115Z'
                  transform='translate(-1408.758 -456.553)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1925'
                  data-name='Path 1925'
                  d='M1418.587,465.932l-1.621.877a.125.125,0,0,1-.169-.048l-.01-.023-.483-1.707a.113.113,0,0,1,.056-.124l1.621-.879a.125.125,0,0,1,.169.048l.01.023.483,1.709A.112.112,0,0,1,1418.587,465.932Z'
                  transform='translate(-1408.343 -456.778)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1926'
                  data-name='Path 1926'
                  d='M1420.787,464.715l-1.621.877a.125.125,0,0,1-.168-.05l-.008-.019-.484-1.708a.115.115,0,0,1,.057-.124l1.62-.877a.124.124,0,0,1,.168.05l.008.018.483,1.709A.111.111,0,0,1,1420.787,464.715Z'
                  transform='translate(-1407.925 -457.009)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1927'
                  data-name='Path 1927'
                  d='M1422.99,463.5l-1.621.877a.125.125,0,0,1-.169-.048l-.01-.023-.483-1.707a.115.115,0,0,1,.056-.131l1.621-.877a.124.124,0,0,1,.168.049l.01.021.483,1.708A.116.116,0,0,1,1422.99,463.5Z'
                  transform='translate(-1407.507 -457.242)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1928'
                  data-name='Path 1928'
                  d='M1425.243,462.311l-1.621.878a.125.125,0,0,1-.169-.05l-.008-.02-.483-1.709a.114.114,0,0,1,.056-.124l1.621-.877a.125.125,0,0,1,.169.048l.01.023.483,1.708A.113.113,0,0,1,1425.243,462.311Z'
                  transform='translate(-1407.078 -457.466)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1929'
                  data-name='Path 1929'
                  d='M1427.435,461.088l-1.621.877a.123.123,0,0,1-.168-.048l-.01-.021-.483-1.708a.11.11,0,0,1,.056-.124l1.62-.877a.124.124,0,0,1,.169.046l.01.022.483,1.709A.111.111,0,0,1,1427.435,461.088Z'
                  transform='translate(-1406.661 -457.699)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1930'
                  data-name='Path 1930'
                  d='M1429.69,459.852l-1.621.877a.125.125,0,0,1-.168-.049l-.008-.021-.483-1.708a.113.113,0,0,1,.056-.124l1.621-.877a.123.123,0,0,1,.169.046l.01.023.483,1.709A.114.114,0,0,1,1429.69,459.852Z'
                  transform='translate(-1406.232 -457.934)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
            </g>
          </g>
        </g>
        <g id='windmill' transform='translate(433.149)'>
          <g id='Group_2969' data-name='Group 2969'>
            <path
              id='Path_1933'
              data-name='Path 1933'
              d='M986.416,229.246h-3.083l-2.6,138.871a1.949,1.949,0,0,0,1.212,1.6,6.811,6.811,0,0,0,5.852,0,1.949,1.949,0,0,0,1.21-1.6h0Z'
              transform='translate(-944.245 -168.478)'
              fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
            />
            <g id='Group_2967' data-name='Group 2967' transform='translate(30.898 48.98)'>
              <path
                id='Path_1934'
                data-name='Path 1934'
                d='M994.083,244.1l11.692-15.192-16.109-8.793h0c-1.353-1.091-3.6-1.066-6.136.321-4.133,2.254-7.482,7.249-7.482,11.155a4.039,4.039,0,0,0,1.407,3.36h0l.011.006a3.306,3.306,0,0,0,.841.461Z'
                transform='translate(-976.036 -219.341)'
                fill='#639'
              />
              <ellipse
                id='Ellipse_1541'
                data-name='Ellipse 1541'
                cx='9.61'
                cy='5.506'
                rx='9.61'
                ry='5.506'
                transform='matrix(0.643, -0.766, 0.766, 0.643, 13.308, 20.861)'
                fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
              />
            </g>
            <g id='Group_2968' data-name='Group 2968'>
              <path
                id='Path_1935'
                data-name='Path 1935'
                d='M997.769,179.085v66.1c0,1.993,2.552,1.6,4.043-.624l6.221-9.276c4.734-7.059,6.512-14.587,4.639-19.641l-13.83-37.284C998.663,177.879,997.769,178.488,997.769,179.085Z'
                transform='translate(-941.007 -178.185)'
                fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
              />
              <path
                id='Path_1936'
                data-name='Path 1936'
                d='M950.9,303.853l60.55-66.093c1.827-2,1.467-4.386-.571-3.791l-8.5,2.486c-6.467,1.891-13.364,7.48-17.993,14.579l-34.156,52.378C949.8,304.082,950.351,304.453,950.9,303.853Z'
                transform='translate(-950.075 -167.597)'
                fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
              />
              <path
                id='Path_1937'
                data-name='Path 1937'
                d='M1065.2,230.246H1004.65c-1.827,0-4.017,2.785-3.47,4.413l2.277,6.791c1.732,5.167,6.849,7.109,13.357,5.063l47.987-15.1C1065.412,231.224,1065.749,230.246,1065.2,230.246Z'
                transform='translate(-940.374 -168.288)'
                fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
              />
            </g>
            <ellipse
              id='Ellipse_1542'
              data-name='Ellipse 1542'
              cx='8.672'
              cy='4.969'
              rx='8.672'
              ry='4.969'
              transform='translate(51.388 71.733) rotate(-49.976)'
              fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
            />
            <path
              id='Path_1938'
              data-name='Path 1938'
              d='M1009.8,235.017l-1.834-4.142L998.7,243.8l5.549-.471h0a4.279,4.279,0,0,0,2.079-.594,7.918,7.918,0,0,0,4.062-6.051A3.976,3.976,0,0,0,1009.8,235.017Z'
              transform='translate(-940.829 -168.168)'
              fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
            />
          </g>
        </g>
        <g id='Group_2903' data-name='Group 2903' transform='translate(0 522.521)'>
          <path
            id='Path_1699'
            data-name='Path 1699'
            d='M702.186,670.624v32.231l-.934.509-28.7,15.662-1.627.889-6.247,3.344V690.384c0-.106-.007-.187-.011-.276v-.122c0-.064-.008-.127-.013-.194-.008-.11-.018-.219-.03-.33a.273.273,0,0,0-.007-.076c-.007-.024,0-.048-.007-.07a.871.871,0,0,1-.014-.1c-.011-.107-.024-.218-.041-.326v-.012l-.03-.181a.312.312,0,0,0-.011-.067l-.013-.083-.016-.1c-.018-.1-.038-.2-.057-.306l-.018-.089c-.015-.081-.033-.164-.051-.245l-.021-.108-.032-.137-.016-.063c-.012-.055-.026-.11-.039-.164s-.029-.11-.043-.164l-.008-.031c-.017-.065-.033-.13-.051-.194s-.025-.1-.039-.138c-.021-.076-.043-.15-.064-.224l-.043-.138c-.018-.057-.036-.117-.056-.175l-.024-.079c-.037-.112-.071-.224-.108-.332l-.117-.333c-.03-.08-.058-.156-.086-.233l-.021-.057c-.018-.045-.033-.089-.052-.137s-.049-.13-.076-.2-.037-.094-.055-.138l-.1-.252c-.031-.07-.058-.138-.09-.212-.013-.036-.03-.073-.045-.107l-.069-.156c-.023-.054-.045-.1-.07-.156s-.044-.1-.069-.15-.044-.1-.068-.145q-.12-.254-.244-.5c-.024-.045-.045-.089-.068-.138-.082-.161-.165-.321-.252-.481-.026-.05-.052-.1-.081-.151s-.042-.076-.063-.113l-.159-.287c-.056-.1-.11-.189-.165-.286-.031-.052-.061-.106-.094-.159-.008-.016-.018-.031-.027-.045s-.032-.055-.05-.082c-.033-.056-.067-.112-.1-.168a.922.922,0,0,0-.052-.088c-.014-.026-.032-.051-.049-.076l-.086-.138c-.063-.1-.126-.2-.193-.3-.028-.046-.058-.093-.09-.138-.045-.069-.091-.138-.138-.206l-.023-.032c-.062-.092-.124-.183-.188-.276l-.006-.012c-.075-.1-.15-.212-.224-.318s-.151-.211-.23-.314-.154-.208-.232-.312-.156-.207-.237-.311-.145-.188-.22-.276-.157-.2-.237-.294c-.031-.038-.061-.076-.093-.114q-.355-.43-.728-.845l-.236-.263c-.12-.131-.245-.262-.368-.391s-.237-.245-.361-.37l-.031-.033c-.024-.023-.049-.044-.069-.067s-.058-.062-.088-.089c-.1-.094-.193-.189-.29-.276s-.193-.187-.292-.276l-.051-.048-.081-.076-.073-.067-.246-.224c-.055-.049-.107-.1-.163-.138l-.011-.007c-.039-.038-.08-.071-.12-.107-.087-.074-.173-.149-.261-.22l-.113-.1-.138-.112-.018-.014-.154-.125-.068-.056c-.027-.024-.056-.045-.087-.068s-.1-.081-.151-.12q-.225-.177-.453-.345c-.055-.042-.108-.082-.165-.123-.35-.261-.708-.506-1.071-.738-.073-.05-.148-.1-.219-.138s-.164-.1-.249-.155h0l-.031-.018h0c-.075-.049-.155-.094-.23-.138s-.17-.1-.257-.151c-.037-.023-.071-.042-.11-.063s-.108-.062-.164-.089a.526.526,0,0,0-.073-.04l-.049-.026,37.5-20.081C696.513,655.559,702.186,664.012,702.186,670.624Z'
            transform='translate(-573.592 -610.665)'
            fill='#283568'
          />
          <path
            id='Path_1700'
            data-name='Path 1700'
            d='M701.241,671.087v32.189l-28.7,15.662-1.627.889-6.247,3.344V690.295c0-.106-.007-.187-.012-.276V689.9c0-.064-.008-.127-.012-.194-.008-.108-.018-.219-.031-.328a.32.32,0,0,0-.006-.075c-.007-.025,0-.049-.007-.071s-.008-.069-.014-.1c-.011-.108-.025-.219-.042-.327-.011-.064-.019-.127-.03-.19a.621.621,0,0,0-.01-.068c-.008-.058-.018-.119-.03-.18-.018-.1-.037-.2-.056-.306l-.018-.089c-.016-.081-.033-.164-.051-.245l-.023-.108-.031-.137-.016-.063-.039-.164-.043-.164-.01-.031c-.014-.064-.031-.13-.051-.194s-.024-.1-.038-.138l-.063-.224-.043-.138-.008-.023c-.023-.077-.045-.155-.07-.231-.037-.112-.072-.224-.108-.332s-.077-.224-.117-.333c-.03-.08-.058-.156-.086-.233l-.021-.056-.052-.138c-.018-.049-.049-.13-.076-.2s-.037-.094-.055-.138l-.1-.252c-.031-.069-.059-.138-.09-.212-.013-.036-.03-.073-.045-.107l-.069-.156c-.021-.052-.045-.1-.07-.156s-.044-.1-.069-.149-.044-.1-.068-.149c-.08-.168-.161-.337-.244-.5-.023-.045-.045-.089-.068-.138-.082-.161-.165-.321-.252-.481-.026-.05-.052-.1-.081-.151s-.042-.076-.063-.113l-.16-.287c-.056-.1-.109-.189-.165-.286-.031-.055-.061-.107-.094-.16-.008-.015-.017-.031-.026-.045l-.05-.082c-.033-.056-.068-.112-.1-.168-.017-.03-.033-.058-.054-.088s-.032-.051-.046-.076l-.086-.138c-.064-.1-.129-.2-.194-.3-.029-.046-.057-.093-.09-.138-.044-.069-.09-.138-.138-.206l-.023-.032c-.062-.093-.124-.185-.188-.276l-.006-.012-.223-.318c-.075-.106-.151-.212-.23-.314s-.152-.209-.231-.313-.157-.207-.238-.308-.138-.188-.219-.276-.158-.2-.238-.294c-.03-.038-.061-.076-.093-.113q-.355-.432-.728-.846l-.236-.263c-.12-.131-.244-.262-.368-.39s-.237-.245-.358-.37l-.032-.033-.069-.067c-.03-.031-.058-.061-.088-.089-.1-.094-.19-.189-.29-.276s-.193-.187-.29-.276l-.051-.048-.082-.076c-.024-.024-.048-.045-.073-.067-.081-.075-.164-.15-.245-.223a2.018,2.018,0,0,0-.163-.138l-.012-.008c-.038-.038-.08-.071-.12-.107-.087-.074-.173-.149-.26-.22l-.113-.1-.138-.112-.018-.014-.155-.125-.067-.056-.239-.188c-.149-.118-.3-.233-.452-.344-.056-.043-.109-.083-.167-.124q-.525-.391-1.071-.738c-.073-.05-.148-.1-.219-.138s-.164-.1-.249-.155h0l-.03-.018h0l-.231-.138c-.086-.051-.17-.1-.257-.15-.037-.024-.071-.043-.108-.064s-.111-.062-.164-.089a.631.631,0,0,0-.074-.04l1.495-.8,35.029-18.755C695.571,656.019,701.241,664.475,701.241,671.087Z'
            transform='translate(-573.583 -610.577)'
            fill='#283568'
          />
          <path
            id='Path_1701'
            data-name='Path 1701'
            d='M711.114,670.818v32.189L676.18,718.669l-7.782,3.424V689.536c0-6.59-6.862-15.016-15.34-18.848L695.7,651.933C704.212,655.75,711.114,664.207,711.114,670.818Z'
            transform='translate(-581.901 -611.566)'
            fill='url(#linear-gradient-12)'
          />
          <path
            id='Path_1702'
            data-name='Path 1702'
            d='M671.215,697.272v6.979l-12.664,6.783V682.425L617.636,660.14V619.449c0-2.118,1.817-2.844,4.06-1.621l74.36,40.481-37.5,20.08C665.547,682.205,671.215,690.66,671.215,697.272Z'
            transform='translate(-580.129 -617.234)'
            fill='#283568'
          />
          <path
            id='Path_1703'
            data-name='Path 1703'
            d='M677.206,694.063V726.62l-91.085-49.61V636.32c0-2.118,1.817-2.844,4.06-1.622l33.447,18.209,40.915,22.274C671.539,679,677.206,687.452,677.206,694.063Z'
            transform='translate(-586.121 -614.026)'
            fill='#639'
          />
          <path
            id='Path_1704'
            data-name='Path 1704'
            d='M701.4,658.207l-37.505,20.08L622.984,656.02l-33.447-18.208,33.447-17.907,4.058-2.173Z'
            transform='translate(-585.472 -617.139)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1705'
            data-name='Path 1705'
            d='M700.167,675.738V698.3l-.933.509-28.7,15.663-1.629.888-6.246,3.344v-22.5l1.478-.808,35.093-19.151Z'
            transform='translate(-571.569 -606.11)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1708'
            data-name='Path 1708'
            d='M599.076,660.973l-5.139-2.805a2.445,2.445,0,0,1-1.273-2.145v-7.6a2.443,2.443,0,0,1,3.614-2.145l5.139,2.8a2.443,2.443,0,0,1,1.273,2.146v7.6A2.444,2.444,0,0,1,599.076,660.973Z'
            transform='translate(-584.877 -611.768)'
            fill='#00d8e0'
          />
          <path
            id='Path_1708-2'
            data-name='Path 1708'
            d='M610.726,667.4l-5.14-2.805a2.444,2.444,0,0,1-1.272-2.145v-7.6a2.443,2.443,0,0,1,3.614-2.145l5.139,2.8a2.444,2.444,0,0,1,1.272,2.146v7.6A2.443,2.443,0,0,1,610.726,667.4Z'
            transform='translate(-582.662 -610.547)'
            fill='#00d8e0'
          />
          <path
            id='Path_1708-3'
            data-name='Path 1708'
            d='M622.375,673.589l-5.139-2.8a2.442,2.442,0,0,1-1.272-2.145v-7.6a2.443,2.443,0,0,1,3.613-2.145l5.139,2.805a2.442,2.442,0,0,1,1.273,2.145v7.6A2.443,2.443,0,0,1,622.375,673.589Z'
            transform='translate(-580.447 -609.37)'
            fill='#00d8e0'
          />
          <path
            id='Path_1710'
            data-name='Path 1710'
            d='M654.337,713.623,634.525,702.81V665.255l19.812,10.814Z'
            transform='translate(-576.918 -608.104)'
            fill='#00d8e0'
          />
          <rect
            id='Rectangle_2670'
            data-name='Rectangle 2670'
            width='0.584'
            height='37.37'
            transform='translate(67.221 62.558)'
            fill='#caf3f2'
          />
          <ellipse
            id='Ellipse_1522'
            data-name='Ellipse 1522'
            cx='5.373'
            cy='3.079'
            rx='5.373'
            ry='3.079'
            transform='translate(95.988 98.281) rotate(-49.975)'
            fill='#0fa'
          />
          <ellipse
            id='Ellipse_1523'
            data-name='Ellipse 1523'
            cx='5.373'
            cy='3.079'
            rx='5.373'
            ry='3.079'
            transform='translate(116.446 88.037) rotate(-49.976)'
            fill='#0fa'
          />
        </g>
        <g id='Group_2930' data-name='Group 2930' transform='translate(410.971 681.081)'>
          <g id='Group_2919' data-name='Group 2919' transform='translate(3.15 136.958)'>
            <path
              id='Path_1744'
              data-name='Path 1744'
              d='M960.511,874.178v-1.832h-.381a7.676,7.676,0,0,0-3.488-3.37,21.721,21.721,0,0,0-18.689,0,7.679,7.679,0,0,0-3.485,3.37h-.383V874.2h0c.056,1.8,1.345,3.6,3.864,4.969a21.721,21.721,0,0,0,18.689,0c2.484-1.359,3.779-3.128,3.864-4.909h0Z'
              transform='translate(-934.085 -865.292)'
              fill='#283568'
            />
            <ellipse
              id='Ellipse_1524'
              data-name='Ellipse 1524'
              cx='13.214'
              cy='7.212'
              rx='13.214'
              ry='7.212'
              fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
            />
          </g>
          <g id='Group_2920' data-name='Group 2920' transform='translate(11.395 136.736)'>
            <path
              id='Path_1745'
              data-name='Path 1745'
              d='M950.947,873.829V867.84h-.138a2.886,2.886,0,0,0-1.31-1.268,8.158,8.158,0,0,0-7.026,0,2.884,2.884,0,0,0-1.312,1.268h-.138v6h0a2.369,2.369,0,0,0,1.455,1.869,8.166,8.166,0,0,0,7.027,0,2.383,2.383,0,0,0,1.452-1.844h0Z'
              transform='translate(-941.012 -865.276)'
              fill='#283568'
            />
            <ellipse
              id='Ellipse_1525'
              data-name='Ellipse 1525'
              cx='4.967'
              cy='2.712'
              rx='4.967'
              ry='2.712'
              fill='#0fa'
            />
          </g>
          <path
            id='Path_1746'
            data-name='Path 1746'
            d='M943.219,764.573,942.2,885.936h0a1.741,1.741,0,0,0,1.038,1.275,5.855,5.855,0,0,0,5.034,0,1.752,1.752,0,0,0,1.037-1.275h0l-1.022-121.363Z'
            transform='translate(-929.393 -747.781)'
            fill='#283568'
          />
          <path
            id='Path_1747'
            data-name='Path 1747'
            d='M947.671,770.331,978.5,787.113a1.068,1.068,0,0,1,0,1.9h0a1.221,1.221,0,0,1-1.159,0L945.365,771.56Z'
            transform='translate(-928.791 -746.686)'
            fill='#283568'
          />
          <g id='Group_2921' data-name='Group 2921' transform='translate(39.202 61.208)'>
            <path
              id='Path_1748'
              data-name='Path 1748'
              d='M978.48,847.409l-14.1-7.7v-35.5l14.1,7.7Z'
              transform='translate(-964.378 -801.452)'
              fill='#639'
            />
            <path
              id='Path_1749'
              data-name='Path 1749'
              d='M964.379,804.655l4.769-2.761,14.1,7.7-4.769,2.76Z'
              transform='translate(-964.378 -801.894)'
              fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
            />
            <path
              id='Path_1750'
              data-name='Path 1750'
              d='M976.228,846.621,981,843.86v-35.5l-4.769,2.76Z'
              transform='translate(-962.125 -800.664)'
              fill='#0fa'
            />
          </g>
          <rect
            id='Rectangle_2671'
            data-name='Rectangle 2671'
            width='0.511'
            height='24.535'
            transform='translate(48.383 42.33)'
            fill='#361a47'
          />
          <g id='Group_2922' data-name='Group 2922' transform='translate(40.742 69.547)'>
            <ellipse
              id='Ellipse_1526'
              data-name='Ellipse 1526'
              cx='2.842'
              cy='4.959'
              rx='2.842'
              ry='4.959'
              transform='translate(0 3.655) rotate(-40.025)'
              fill='#f74f86'
            />
            <ellipse
              id='Ellipse_1527'
              data-name='Ellipse 1527'
              cx='2.842'
              cy='4.96'
              rx='2.842'
              ry='4.96'
              transform='matrix(0.766, -0.643, 0.643, 0.766, 0, 13.527)'
              fill='#f96'
            />
            <ellipse
              id='Ellipse_1528'
              data-name='Ellipse 1528'
              cx='2.842'
              cy='4.96'
              rx='2.842'
              ry='4.96'
              transform='matrix(0.766, -0.643, 0.643, 0.766, 0, 23.398)'
              fill='#0fa'
            />
          </g>
          <g id='Group_2929' data-name='Group 2929'>
            <path
              id='Path_1751'
              data-name='Path 1751'
              d='M960.065,764.363l-3.639-12.9.607-.261-1.115-.614-.057-.032h-.006a.965.965,0,0,0-.882.02L931.9,763.17a.85.85,0,0,0-.428.978l3.744,13.25a.868.868,0,0,0,.437.534h0l1.159.639-.138-.7,22.962-12.527A.854.854,0,0,0,960.065,764.363Z'
              transform='translate(-931.439 -750.464)'
              fill='#0fa'
            />
            <path
              id='Path_1752'
              data-name='Path 1752'
              d='M960.629,765.893l-23.072,12.589a.938.938,0,0,1-1.277-.361.873.873,0,0,1-.074-.168l-3.745-13.259a.853.853,0,0,1,.431-.978l23.072-12.589a.94.94,0,0,1,1.28.362.967.967,0,0,1,.074.168l3.742,13.259A.852.852,0,0,1,960.629,765.893Z'
              transform='translate(-931.25 -750.36)'
              fill='#f7f7ff'
            />
            <g id='Group_2928' data-name='Group 2928' transform='translate(2.29 1.979)'>
              <g id='Group_2923' data-name='Group 2923'>
                <path
                  id='Path_1753'
                  data-name='Path 1753'
                  d='M935.617,763.609l-1.6.865a.121.121,0,0,1-.165-.045l-.01-.023-.476-1.686a.106.106,0,0,1,.055-.125l1.6-.868a.123.123,0,0,1,.166.046l.009.023.476,1.685A.112.112,0,0,1,935.617,763.609Z'
                  transform='translate(-933.363 -750.304)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1754'
                  data-name='Path 1754'
                  d='M937.8,762.4l-1.6.866a.122.122,0,0,1-.165-.047l-.01-.023-.476-1.685a.112.112,0,0,1,.055-.127l1.6-.865a.121.121,0,0,1,.165.046l.01.023.477,1.685A.111.111,0,0,1,937.8,762.4Z'
                  transform='translate(-932.947 -750.534)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1755'
                  data-name='Path 1755'
                  d='M940.066,761.19l-1.6.867a.121.121,0,0,1-.165-.047l-.01-.023-.478-1.685a.112.112,0,0,1,.057-.127l1.6-.865a.122.122,0,0,1,.165.047l.01.021.476,1.686A.11.11,0,0,1,940.066,761.19Z'
                  transform='translate(-932.518 -750.763)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1756'
                  data-name='Path 1756'
                  d='M942.215,760.023l-1.6.865a.12.12,0,0,1-.165-.046l-.01-.023-.477-1.685a.112.112,0,0,1,.056-.126l1.6-.866a.122.122,0,0,1,.165.046l.01.023.476,1.686A.111.111,0,0,1,942.215,760.023Z'
                  transform='translate(-932.109 -750.985)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1757'
                  data-name='Path 1757'
                  d='M944.381,758.823l-1.6.865a.123.123,0,0,1-.167-.049l-.008-.019-.476-1.686a.109.109,0,0,1,.055-.126l1.6-.866a.122.122,0,0,1,.165.046l.009.023.478,1.685A.113.113,0,0,1,944.381,758.823Z'
                  transform='translate(-931.697 -751.214)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1758'
                  data-name='Path 1758'
                  d='M946.56,757.618l-1.6.865a.121.121,0,0,1-.165-.046l-.01-.023-.477-1.685a.113.113,0,0,1,.057-.127l1.6-.865a.122.122,0,0,1,.166.047l.011.023.476,1.685A.112.112,0,0,1,946.56,757.618Z'
                  transform='translate(-931.283 -751.443)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1759'
                  data-name='Path 1759'
                  d='M948.781,756.45l-1.6.865a.121.121,0,0,1-.165-.045l-.01-.023-.476-1.686a.106.106,0,0,1,.056-.125l1.6-.867a.122.122,0,0,1,.164.045l.009.024.478,1.685A.111.111,0,0,1,948.781,756.45Z'
                  transform='translate(-930.861 -751.665)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1760'
                  data-name='Path 1760'
                  d='M950.945,755.244l-1.6.868a.12.12,0,0,1-.165-.046l-.01-.023-.477-1.685a.11.11,0,0,1,.057-.126l1.6-.868a.123.123,0,0,1,.167.05l.01.019.476,1.685A.111.111,0,0,1,950.945,755.244Z'
                  transform='translate(-930.449 -751.894)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1761'
                  data-name='Path 1761'
                  d='M953.17,754.023l-1.6.865a.121.121,0,0,1-.165-.046l-.011-.021-.476-1.686a.11.11,0,0,1,.057-.126l1.6-.866a.121.121,0,0,1,.163.045l.011.024.477,1.685A.11.11,0,0,1,953.17,754.023Z'
                  transform='translate(-930.026 -752.126)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2924' data-name='Group 2924' transform='translate(0.734 2.606)'>
                <path
                  id='Path_1762'
                  data-name='Path 1762'
                  d='M936.233,765.8l-1.6.865a.122.122,0,0,1-.165-.047l-.01-.023-.476-1.685a.113.113,0,0,1,.055-.127l1.6-.865a.119.119,0,0,1,.164.044.079.079,0,0,1,.011.025l.476,1.685A.113.113,0,0,1,936.233,765.8Z'
                  transform='translate(-933.98 -752.493)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1763'
                  data-name='Path 1763'
                  d='M938.42,764.589l-1.6.865a.12.12,0,0,1-.164-.043.11.11,0,0,1-.011-.026l-.476-1.685a.111.111,0,0,1,.055-.126l1.6-.866a.122.122,0,0,1,.166.046l.009.022.477,1.685A.113.113,0,0,1,938.42,764.589Z'
                  transform='translate(-933.564 -752.723)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1764'
                  data-name='Path 1764'
                  d='M940.682,763.379l-1.6.868a.121.121,0,0,1-.165-.046l-.011-.022-.477-1.685a.112.112,0,0,1,.057-.127l1.6-.868a.124.124,0,0,1,.168.051l.007.018.476,1.686A.109.109,0,0,1,940.682,763.379Z'
                  transform='translate(-933.134 -752.953)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1765'
                  data-name='Path 1765'
                  d='M942.831,762.213l-1.6.865a.121.121,0,0,1-.165-.047l-.011-.023-.476-1.685a.112.112,0,0,1,.056-.127l1.6-.865a.12.12,0,0,1,.164.044.1.1,0,0,1,.011.025l.477,1.685A.117.117,0,0,1,942.831,762.213Z'
                  transform='translate(-932.726 -753.175)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1766'
                  data-name='Path 1766'
                  d='M945,761.012l-1.6.867a.123.123,0,0,1-.167-.049l-.008-.019-.476-1.686A.109.109,0,0,1,942.8,760l1.6-.868a.12.12,0,0,1,.166.046l.01.023.478,1.685A.109.109,0,0,1,945,761.012Z'
                  transform='translate(-932.313 -753.403)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1767'
                  data-name='Path 1767'
                  d='M947.175,759.807l-1.6.866a.121.121,0,0,1-.164-.044.135.135,0,0,1-.011-.025l-.476-1.685a.112.112,0,0,1,.055-.127l1.6-.865a.122.122,0,0,1,.165.046l.01.023.476,1.685A.111.111,0,0,1,947.175,759.807Z'
                  transform='translate(-931.899 -753.632)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1768'
                  data-name='Path 1768'
                  d='M949.4,758.64l-1.6.865a.12.12,0,0,1-.163-.045l-.011-.024-.477-1.685a.11.11,0,0,1,.056-.127l1.6-.865a.121.121,0,0,1,.165.046l.01.023.477,1.685A.112.112,0,0,1,949.4,758.64Z'
                  transform='translate(-931.477 -753.854)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1769'
                  data-name='Path 1769'
                  d='M951.562,757.434l-1.6.866a.123.123,0,0,1-.167-.05l-.008-.019-.476-1.686a.111.111,0,0,1,.055-.126l1.6-.868a.122.122,0,0,1,.167.049l.008.02.477,1.685A.114.114,0,0,1,951.562,757.434Z'
                  transform='translate(-931.065 -754.083)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1770'
                  data-name='Path 1770'
                  d='M953.785,756.212l-1.6.865a.119.119,0,0,1-.163-.044l-.011-.023-.477-1.688a.106.106,0,0,1,.057-.125l1.6-.866a.12.12,0,0,1,.165.046l.01.023.476,1.685A.111.111,0,0,1,953.785,756.212Z'
                  transform='translate(-930.643 -754.315)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2925' data-name='Group 2925' transform='translate(1.478 5.213)'>
                <path
                  id='Path_1771'
                  data-name='Path 1771'
                  d='M936.86,767.994l-1.6.865a.121.121,0,0,1-.165-.045l-.01-.022-.477-1.687a.106.106,0,0,1,.056-.125l1.6-.869a.122.122,0,0,1,.167.05l.009.019.476,1.685A.111.111,0,0,1,936.86,767.994Z'
                  transform='translate(-934.605 -754.683)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1772'
                  data-name='Path 1772'
                  d='M939.046,766.784l-1.6.866a.12.12,0,0,1-.162-.043.249.249,0,0,1-.012-.026L936.8,765.9a.109.109,0,0,1,.056-.127l1.6-.865a.121.121,0,0,1,.165.047l.011.023.476,1.685A.11.11,0,0,1,939.046,766.784Z'
                  transform='translate(-934.19 -754.913)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1773'
                  data-name='Path 1773'
                  d='M941.309,765.574l-1.6.868a.121.121,0,0,1-.165-.046l-.009-.023-.476-1.685a.11.11,0,0,1,.056-.127l1.6-.865a.122.122,0,0,1,.165.046l.009.021.48,1.686A.108.108,0,0,1,941.309,765.574Z'
                  transform='translate(-933.76 -755.142)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1774'
                  data-name='Path 1774'
                  d='M943.458,764.407l-1.6.865a.121.121,0,0,1-.165-.047l-.01-.023-.479-1.685a.114.114,0,0,1,.057-.127l1.6-.865a.122.122,0,0,1,.165.046l.01.023.476,1.685A.112.112,0,0,1,943.458,764.407Z'
                  transform='translate(-933.351 -755.365)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1775'
                  data-name='Path 1775'
                  d='M945.625,763.207l-1.6.868a.121.121,0,0,1-.165-.046l-.011-.023-.476-1.685a.112.112,0,0,1,.056-.127l1.6-.866a.123.123,0,0,1,.167.049l.008.02.476,1.686A.11.11,0,0,1,945.625,763.207Z'
                  transform='translate(-932.939 -755.593)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1776'
                  data-name='Path 1776'
                  d='M947.8,762l-1.6.865a.121.121,0,0,1-.163-.045l-.011-.024-.477-1.685a.112.112,0,0,1,.056-.127l1.6-.865a.122.122,0,0,1,.164.045l.01.024.478,1.685A.112.112,0,0,1,947.8,762Z'
                  transform='translate(-932.525 -755.822)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1777'
                  data-name='Path 1777'
                  d='M950.026,760.835l-1.6.865a.122.122,0,0,1-.167-.049l-.01-.019-.476-1.686a.11.11,0,0,1,.056-.125l1.6-.868a.122.122,0,0,1,.165.047l.01.023.477,1.685A.112.112,0,0,1,950.026,760.835Z'
                  transform='translate(-932.102 -756.044)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1778'
                  data-name='Path 1778'
                  d='M952.188,759.629l-1.6.866a.121.121,0,0,1-.163-.046l-.009-.023-.477-1.685a.111.111,0,0,1,.057-.127l1.6-.865a.122.122,0,0,1,.166.046l.009.021.476,1.686A.107.107,0,0,1,952.188,759.629Z'
                  transform='translate(-931.691 -756.273)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1779'
                  data-name='Path 1779'
                  d='M954.414,758.4l-1.6.865a.121.121,0,0,1-.165-.045l-.009-.023-.476-1.686a.107.107,0,0,1,.055-.125l1.6-.868a.122.122,0,0,1,.165.046l.01.023.479,1.685A.113.113,0,0,1,954.414,758.4Z'
                  transform='translate(-931.268 -756.506)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2926' data-name='Group 2926' transform='translate(2.225 7.867)'>
                <path
                  id='Path_1780'
                  data-name='Path 1780'
                  d='M937.486,770.215l-1.6.865a.121.121,0,0,1-.165-.047l-.01-.023-.476-1.685a.112.112,0,0,1,.057-.127l1.6-.865a.12.12,0,0,1,.163.045l.011.024.477,1.685A.112.112,0,0,1,937.486,770.215Z'
                  transform='translate(-935.233 -756.914)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1781'
                  data-name='Path 1781'
                  d='M939.675,769l-1.6.869a.123.123,0,0,1-.166-.046l-.009-.023-.476-1.685a.113.113,0,0,1,.055-.127l1.6-.865a.121.121,0,0,1,.165.045l.01.023.477,1.686A.1.1,0,0,1,939.675,769Z'
                  transform='translate(-934.817 -757.144)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1782'
                  data-name='Path 1782'
                  d='M941.937,767.8l-1.6.865a.123.123,0,0,1-.167-.047l-.01-.021-.476-1.686a.11.11,0,0,1,.056-.126l1.6-.868a.122.122,0,0,1,.165.046l.009.023.476,1.685A.111.111,0,0,1,941.937,767.8Z'
                  transform='translate(-934.387 -757.375)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1783'
                  data-name='Path 1783'
                  d='M944.085,766.628l-1.6.867a.118.118,0,0,1-.163-.045l-.011-.024-.477-1.685a.109.109,0,0,1,.057-.127l1.6-.865a.122.122,0,0,1,.165.046l.01.021.476,1.686A.107.107,0,0,1,944.085,766.628Z'
                  transform='translate(-933.978 -757.596)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1784'
                  data-name='Path 1784'
                  d='M946.254,765.429l-1.6.865a.122.122,0,0,1-.165-.047l-.01-.023L944,764.54a.11.11,0,0,1,.056-.128l1.6-.865a.121.121,0,0,1,.165.047l.01.023.477,1.685A.113.113,0,0,1,946.254,765.429Z'
                  transform='translate(-933.566 -757.824)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1785'
                  data-name='Path 1785'
                  d='M948.43,764.223l-1.6.866a.123.123,0,0,1-.167-.049l-.008-.02-.477-1.685a.114.114,0,0,1,.056-.127l1.6-.865a.121.121,0,0,1,.166.045l.009.023.477,1.686A.111.111,0,0,1,948.43,764.223Z'
                  transform='translate(-933.153 -758.054)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1786'
                  data-name='Path 1786'
                  d='M950.654,763.056l-1.6.865a.121.121,0,0,1-.165-.046l-.009-.022-.476-1.685a.113.113,0,0,1,.055-.127l1.6-.865a.122.122,0,0,1,.165.046l.01.023.476,1.685A.111.111,0,0,1,950.654,763.056Z'
                  transform='translate(-932.729 -758.275)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1787'
                  data-name='Path 1787'
                  d='M952.817,761.85l-1.6.865a.12.12,0,0,1-.165-.046l-.01-.021-.476-1.686a.107.107,0,0,1,.055-.126l1.6-.868a.121.121,0,0,1,.165.046l.01.023.479,1.685A.113.113,0,0,1,952.817,761.85Z'
                  transform='translate(-932.318 -758.505)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1788'
                  data-name='Path 1788'
                  d='M955.04,760.633l-1.6.865a.12.12,0,0,1-.164-.043.106.106,0,0,1-.011-.026l-.476-1.685a.111.111,0,0,1,.055-.126l1.6-.866a.122.122,0,0,1,.165.047l.011.023.476,1.686A.11.11,0,0,1,955.04,760.633Z'
                  transform='translate(-931.896 -758.736)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
              <g id='Group_2927' data-name='Group 2927' transform='translate(2.983 10.46)'>
                <path
                  id='Path_1789'
                  data-name='Path 1789'
                  d='M938.123,772.4l-1.6.867a.122.122,0,0,1-.166-.046l-.01-.023-.476-1.685a.111.111,0,0,1,.055-.127l1.6-.865a.121.121,0,0,1,.165.045l.011.023.477,1.686A.108.108,0,0,1,938.123,772.4Z'
                  transform='translate(-935.869 -759.093)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1790'
                  data-name='Path 1790'
                  d='M940.313,771.188l-1.6.866a.124.124,0,0,1-.168-.051l-.007-.018-.477-1.686a.108.108,0,0,1,.056-.125l1.6-.868a.122.122,0,0,1,.165.046l.009.023.477,1.685A.113.113,0,0,1,940.313,771.188Z'
                  transform='translate(-935.453 -759.323)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1791'
                  data-name='Path 1791'
                  d='M942.573,769.978l-1.6.866a.123.123,0,0,1-.166-.046l-.009-.023-.476-1.685a.112.112,0,0,1,.055-.127l1.6-.865a.12.12,0,0,1,.165.046l.01.023.476,1.685A.111.111,0,0,1,942.573,769.978Z'
                  transform='translate(-935.023 -759.553)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1792'
                  data-name='Path 1792'
                  d='M944.721,768.814l-1.6.868a.122.122,0,0,1-.167-.049l-.008-.019-.476-1.687a.108.108,0,0,1,.056-.126l1.6-.867a.121.121,0,0,1,.164.046l.01.023.477,1.688A.105.105,0,0,1,944.721,768.814Z'
                  transform='translate(-934.615 -759.774)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1793'
                  data-name='Path 1793'
                  d='M946.888,767.613l-1.6.865a.12.12,0,0,1-.162-.044.113.113,0,0,1-.011-.025l-.479-1.685a.111.111,0,0,1,.057-.127l1.6-.865a.121.121,0,0,1,.165.046l.01.023.476,1.685A.111.111,0,0,1,946.888,767.613Z'
                  transform='translate(-934.203 -760.003)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1794'
                  data-name='Path 1794'
                  d='M949.065,766.4l-1.6.867a.125.125,0,0,1-.168-.052l-.007-.017-.476-1.688a.11.11,0,0,1,.055-.125l1.6-.866a.12.12,0,0,1,.165.045l.011.024.476,1.685A.11.11,0,0,1,949.065,766.4Z'
                  transform='translate(-933.789 -760.233)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1795'
                  data-name='Path 1795'
                  d='M951.29,765.239l-1.6.868a.12.12,0,0,1-.164-.044.148.148,0,0,1-.012-.025l-.477-1.685a.114.114,0,0,1,.057-.127l1.6-.865a.121.121,0,0,1,.165.046l.01.021.476,1.686A.109.109,0,0,1,951.29,765.239Z'
                  transform='translate(-933.366 -760.454)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1796'
                  data-name='Path 1796'
                  d='M953.453,764.034l-1.6.865a.122.122,0,0,1-.165-.046l-.011-.023-.476-1.685a.112.112,0,0,1,.056-.127l1.6-.865a.121.121,0,0,1,.165.046l.01.023.476,1.685A.113.113,0,0,1,953.453,764.034Z'
                  transform='translate(-932.955 -760.683)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
                <path
                  id='Path_1797'
                  data-name='Path 1797'
                  d='M955.677,762.812l-1.6.866a.122.122,0,0,1-.165-.046l-.01-.023-.478-1.685a.114.114,0,0,1,.057-.127l1.6-.865a.121.121,0,0,1,.166.046l.009.023.476,1.685A.111.111,0,0,1,955.677,762.812Z'
                  transform='translate(-932.532 -760.915)'
                  fill={ColorVariables.COLOR.COLOR_PRIMARY_BACKGROUND}
                />
              </g>
            </g>
          </g>
        </g>
        <g id='Group_2903-2' data-name='Group 2903' transform='translate(598.907 121.849)'>
          <path
            id='Path_1699-2'
            data-name='Path 1699'
            d='M1089.872,333.959V366.19l.936.509,28.7,15.662,1.627.889,6.247,3.344V353.719c0-.106.007-.187.012-.276v-.123c0-.064.007-.127.012-.194.008-.109.018-.219.03-.33a.277.277,0,0,1,.007-.076c.007-.025,0-.048.007-.07a.9.9,0,0,0,.014-.1c.011-.107.025-.218.042-.326v-.012l.029-.181a.469.469,0,0,1,.011-.068l.013-.082.017-.1c.018-.1.037-.2.056-.307l.018-.088c.015-.081.033-.164.051-.245l.023-.108.031-.138.016-.062c.012-.055.026-.111.04-.164s.027-.111.043-.164l.008-.032c.016-.064.032-.13.05-.193s.025-.1.039-.138c.021-.076.043-.15.064-.224l.043-.138c.018-.057.036-.117.056-.175l.025-.079c.036-.112.07-.224.107-.333l.118-.332c.028-.08.057-.156.084-.233l.022-.057c.018-.045.033-.089.052-.138s.05-.13.076-.194.037-.094.055-.138l.1-.252c.031-.07.058-.138.09-.212.013-.036.03-.073.045-.107l.069-.156c.024-.055.046-.1.07-.156s.044-.1.069-.15.044-.1.068-.146c.08-.168.162-.337.244-.5.024-.045.045-.089.068-.138.083-.161.166-.321.252-.481.026-.05.052-.1.082-.151s.04-.076.062-.113l.159-.287c.056-.1.109-.189.167-.286.03-.052.059-.107.093-.159a.366.366,0,0,1,.029-.045.805.805,0,0,1,.049-.082c.033-.056.067-.112.1-.168.017-.03.033-.059.052-.088s.032-.051.049-.076l.086-.138c.063-.1.126-.2.193-.3.029-.046.058-.093.092-.138.044-.069.089-.138.138-.206l.021-.032c.062-.093.125-.183.188-.276l.007-.012.224-.318c.074-.106.15-.212.229-.314s.153-.209.232-.313.156-.207.237-.311.145-.187.22-.275.157-.2.237-.3l.093-.113c.237-.287.481-.569.729-.846l.237-.262c.12-.131.244-.262.367-.39s.238-.246.361-.37l.031-.033a.914.914,0,0,0,.069-.068c.022-.023.058-.061.089-.088.1-.094.192-.189.289-.276s.194-.187.292-.276l.051-.048.081-.076c.025-.024.049-.045.074-.067.081-.076.164-.15.245-.224a2.121,2.121,0,0,1,.163-.138l.011-.008c.039-.037.081-.07.12-.106.087-.074.172-.149.26-.22l.113-.1.138-.112.018-.014.154-.126.068-.055c.027-.024.056-.045.087-.068s.1-.081.152-.12q.223-.177.452-.345c.055-.043.108-.082.165-.123q.527-.391,1.071-.738c.073-.05.148-.1.219-.138s.165-.1.249-.155h0l.031-.018h0c.076-.049.155-.094.23-.138s.17-.1.257-.151c.037-.023.073-.043.109-.063s.108-.062.164-.089a.621.621,0,0,1,.073-.04l.049-.026-37.5-20.081C1095.545,318.892,1089.872,327.347,1089.872,333.959Z'
            transform='translate(-1089.253 -274.001)'
            fill='#283568'
          />
          <path
            id='Path_1700-2'
            data-name='Path 1700'
            d='M1090.659,334.422v32.189l28.7,15.662,1.627.889,6.247,3.344V353.63c0-.106.007-.187.012-.276v-.123c0-.064.008-.127.012-.194.008-.108.018-.219.031-.329a.273.273,0,0,1,.007-.076c.006-.024,0-.048.006-.07s.008-.069.014-.1c.011-.107.025-.218.042-.326.011-.064.019-.127.03-.19a.394.394,0,0,1,.012-.068c.008-.058.018-.119.029-.18.018-.1.037-.2.057-.307l.018-.088c.014-.081.032-.164.05-.245l.023-.108.032-.138.014-.062.039-.164.043-.164.009-.032c.015-.063.031-.13.051-.193s.025-.1.038-.138l.063-.224.043-.138.008-.023c.023-.077.046-.155.071-.231.036-.112.07-.224.107-.333s.077-.223.118-.332c.029-.08.057-.156.084-.233l.022-.057c.018-.045.034-.089.052-.138s.05-.13.076-.194.037-.094.055-.138l.1-.252c.031-.069.059-.138.091-.212.013-.036.03-.073.045-.107l.069-.156c.023-.052.045-.1.07-.156s.044-.1.069-.15.044-.1.068-.148c.08-.168.162-.337.244-.5.023-.045.045-.089.068-.138.083-.162.166-.321.252-.482.026-.049.052-.1.082-.15s.04-.076.062-.113l.159-.287c.056-.1.109-.189.167-.286.03-.055.059-.107.093-.159a.515.515,0,0,1,.026-.045l.05-.083c.033-.055.068-.112.1-.167.017-.03.033-.058.054-.088s.032-.051.048-.076l.086-.138c.063-.1.127-.2.193-.3.028-.045.058-.092.092-.138.044-.069.089-.138.137-.2l.023-.032c.062-.093.124-.184.188-.276l.007-.012.221-.318c.075-.106.151-.212.23-.315s.152-.208.232-.312.156-.207.237-.308.138-.188.22-.276.157-.2.237-.294c.031-.038.061-.076.093-.114q.355-.43.728-.846l.236-.262c.12-.131.245-.262.368-.39s.237-.246.358-.37l.032-.033.069-.068c.031-.03.058-.061.088-.088.1-.094.19-.189.29-.276s.193-.187.292-.276l.05-.048.082-.076c.025-.024.048-.045.073-.067.082-.076.164-.15.246-.224a2.05,2.05,0,0,1,.163-.138l.011-.008c.038-.037.08-.07.12-.106.087-.074.173-.149.26-.22l.113-.1.138-.112.018-.014.155-.126.068-.055.238-.188q.225-.177.453-.345c.055-.043.108-.082.165-.123.35-.261.708-.506,1.071-.738.073-.05.147-.1.219-.138s.164-.1.249-.155h0l.031-.018h0l.23-.138c.086-.051.17-.1.257-.151.037-.023.071-.043.109-.063s.11-.062.164-.089a.547.547,0,0,1,.073-.04l-1.495-.8-35.029-18.754C1096.329,319.354,1090.659,327.81,1090.659,334.422Z'
            transform='translate(-1089.104 -273.912)'
            fill='#283568'
          />
          <path
            id='Path_1701-2'
            data-name='Path 1701'
            d='M1090.915,334.153v32.189L1124.508,382l7.483,3.424V352.871c0-6.591,6.6-15.016,14.751-18.848l-41.006-18.755C1097.552,319.085,1090.915,327.542,1090.915,334.153Z'
            transform='translate(-1090.915 -274.902)'
            fill='url(#linear-gradient-13)'
          />
          <path
            id='Path_1702-2'
            data-name='Path 1702'
            d='M1125.356,360.607v6.979l12.664,6.782V345.76l40.915-22.285V282.784c0-2.118-1.817-2.844-4.058-1.621l-74.36,40.481,37.5,20.079C1131.025,345.54,1125.356,353.995,1125.356,360.607Z'
            transform='translate(-1087.229 -280.569)'
            fill='#283568'
          />
          <path
            id='Path_1703-2'
            data-name='Path 1703'
            d='M1121.389,357.4v32.557l91.085-49.61v-40.69c0-2.118-1.816-2.844-4.059-1.622l-33.447,18.209-40.915,22.273C1127.056,342.332,1121.389,350.787,1121.389,357.4Z'
            transform='translate(-1083.261 -277.361)'
            fill='#639'
          />
          <path
            id='Path_1704-2'
            data-name='Path 1704'
            d='M1100.515,321.542l37.505,20.08,40.911-22.266,33.447-18.209-33.447-17.905-4.059-2.173Z'
            transform='translate(-1087.23 -280.474)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1705-2'
            data-name='Path 1705'
            d='M1089.868,339.073v22.561l.933.509,28.7,15.663,1.629.888,6.247,3.344v-22.5l-1.478-.808L1090.8,339.581Z'
            transform='translate(-1089.254 -269.446)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <path
            id='Path_1708-4'
            data-name='Path 1708'
            d='M1181.335,332.9l8.082-4.412a4.38,4.38,0,0,0,2.283-3.846V312.5a4.382,4.382,0,0,0-6.481-3.846l-8.082,4.411a4.384,4.384,0,0,0-2.283,3.848v12.133A4.382,4.382,0,0,0,1181.335,332.9Z'
            transform='translate(-1073.096 -275.331)'
            fill='#00d8e0'
          />
          <path
            id='Path_1709'
            data-name='Path 1709'
            d='M1142.742,353.734l8.082-4.412a4.382,4.382,0,0,0,2.284-3.847V333.343a4.383,4.383,0,0,0-6.483-3.848l-8.082,4.412a4.38,4.38,0,0,0-2.283,3.847v12.133A4.382,4.382,0,0,0,1142.742,353.734Z'
            transform='translate(-1080.433 -271.369)'
            fill='#00d8e0'
          />
          <path
            id='Path_1709-2'
            data-name='Path 1709'
            d='M1162.04,343.695l8.082-4.412a4.383,4.383,0,0,0,2.283-3.846V323.3a4.383,4.383,0,0,0-6.483-3.848l-8.082,4.412a4.383,4.383,0,0,0-2.282,3.846v12.133A4.383,4.383,0,0,0,1162.04,343.695Z'
            transform='translate(-1076.765 -273.278)'
            fill='#00d8e0'
          />
          <ellipse
            id='Ellipse_1522-2'
            data-name='Ellipse 1522'
            cx='3.079'
            cy='5.373'
            rx='3.079'
            ry='5.373'
            transform='translate(21.597 94.013) rotate(-40.025)'
            fill='#0fa'
          />
          <ellipse
            id='Ellipse_1523-2'
            data-name='Ellipse 1523'
            cx='3.079'
            cy='5.373'
            rx='3.079'
            ry='5.373'
            transform='translate(1.14 83.768) rotate(-40.024)'
            fill='#0fa'
          />
        </g>
        <g id='Group_4855' data-name='Group 4855' transform='translate(215.029 183.76)'>
          <path
            id='Path_1931'
            data-name='Path 1931'
            d='M986.058,598.374,921.973,633.35a27.166,27.166,0,0,1-26.031,0l-64.085-34.976a8.2,8.2,0,0,1,0-14.4l64.085-34.976a27.166,27.166,0,0,1,26.031,0l64.085,34.976A8.2,8.2,0,0,1,986.058,598.374Z'
            transform='translate(-738.806 -266.943)'
            opacity='0.8'
            fill='url(#linear-gradient-14)'
          />
          <path
            id='Path_1931-2'
            data-name='Path 1931'
            d='M1034.868,636.635l-79.958,43.64a33.9,33.9,0,0,1-32.479,0l-79.958-43.64c-7.11-3.88-82.311-198-75.2-201.882l169.109-58.9a31.964,31.964,0,0,1,31.477,0l161.3,82.44C1136.269,462.173,1041.979,632.755,1034.868,636.635Z'
            transform='translate(-766.799 -351.282)'
            opacity='0.73'
            fill='url(#linear-gradient-15)'
          />
          <path
            id='Path_1931-3'
            data-name='Path 1931'
            d='M1025.311,611.427l-79.958,43.64a33.9,33.9,0,0,1-32.479,0l-79.958-43.64a10.237,10.237,0,0,1,0-17.971l79.958-43.639a33.9,33.9,0,0,1,32.479,0l79.958,43.639A10.236,10.236,0,0,1,1025.311,611.427Z'
            transform='translate(-757.103 -320.998)'
            fill='url(#linear-gradient-16)'
          />
          <path
            id='Path_1931-4'
            data-name='Path 1931'
            d='M1023.631,604.817l-79.958,43.639a33.9,33.9,0,0,1-32.478,0l-79.958-43.639a10.237,10.237,0,0,1,0-17.971l79.958-43.64a33.9,33.9,0,0,1,32.478,0l79.958,43.64A10.236,10.236,0,0,1,1023.631,604.817Z'
            transform='translate(-755.562 -319.464)'
            fill='url(#linear-gradient-17)'
          />
          <g id='Group_4854' data-name='Group 4854' transform='translate(112.979)'>
            <g id='Group_2947' data-name='Group 2947' transform='translate(140.729)'>
              <g id='Group_2946' data-name='Group 2946' transform='translate(0 4.574)'>
                <path
                  id='Path_14268'
                  data-name='Path 14268'
                  d='M979.977,447.318l57.294,31.271V389.66l-57.294-31.271Z'
                  transform='translate(-979.977 -358.388)'
                  fill='#fc3f72'
                />
              </g>
              <g id='Path_1860' data-name='Path 1860'>
                <path
                  id='Path_14269'
                  data-name='Path 14269'
                  d='M988.192,354.545l-8.215,4.574,57.294,31.271,8.215-4.574Z'
                  transform='translate(-979.977 -354.545)'
                  fill='#ff739e'
                />
              </g>
              <path
                id='Path_1861'
                data-name='Path 1861'
                d='M1028.118,474.324l8.215-4.574v-88.93l-8.215,4.574Z'
                transform='translate(-970.824 -349.55)'
                fill='url(#linear-gradient-18)'
              />
            </g>
            <path
              id='Path_14270'
              data-name='Path 14270'
              d='M928.107,388.617s.844,3.48,1.921,10.04c.133.808-.242,1-.211,1.861.218,6.129.439,12.482-9.853,19.19C919.964,419.708,885.322,398.28,928.107,388.617Z'
              transform='translate(-853.175 -348.068)'
              fill='#fcbf95'
            />
            <path
              id='Path_1875'
              data-name='Path 1875'
              d='M935.743,425.982a10.615,10.615,0,0,0-14,3.544,9.34,9.34,0,0,0,3.551,12.869c.144.08.289.157.437.23a12.7,12.7,0,0,0,1.74.722l34.025,11.048,1.2.389a6.155,6.155,0,0,0,5.773-1.041l27.813-22.986a3.233,3.233,0,0,0,.442-4.6c-.052-.062-.108-.123-.165-.181a3.862,3.862,0,0,0-4.623-.66l-29.281,16.533Z'
              transform='translate(-850.562 -341.211)'
              fill='#fcbf95'
            />
            <g id='Group_4845' data-name='Group 4845' transform='translate(57.237 269.153)'>
              <path
                id='Path_14271'
                data-name='Path 14271'
                d='M910.3,596.66s-2.022-9.146,4.365-10.765,14.133-.977,23.488-4.2l1.047,1.946s-.489,6.467-8.844,9.672-7.9,1.053-13.291,5.316C917.069,598.634,912.477,601.581,910.3,596.66Z'
                transform='translate(-909.79 -580.511)'
                fill='#361a47'
              />
              <path
                id='Path_14272'
                data-name='Path 14272'
                d='M910.243,594.918s-1.807-9.2,4.617-10.648,14.148-.6,23.575-3.569l1,1.974s-.642,6.453-9.066,9.435-7.92.843-13.41,4.962C916.96,597.072,912.3,599.9,910.243,594.918Z'
                transform='translate(-909.788 -580.701)'
                fill='#9953b2'
              />
              <path
                id='Path_14273'
                data-name='Path 14273'
                d='M912.677,584.55s-3.155,4.412,3.388,4.017c0,0,5.784,3.4.931,7.774s-7.053-3.312-7.053-3.312S908.951,587.258,912.677,584.55Z'
                transform='translate(-909.823 -579.969)'
                fill='#8546aa'
              />
            </g>
            <g id='Group_4846' data-name='Group 4846' transform='translate(26.225 259.044)'>
              <path
                id='Path_14274'
                data-name='Path 14274'
                d='M884.064,587.107s-1.645-9.329,4.881-10.687,14.323-.37,23.917-3.214l.974,2.014s-.776,6.514-9.358,9.388-8.027.719-13.663,4.79C890.815,589.4,886.045,592.174,884.064,587.107Z'
                transform='translate(-883.743 -572.017)'
                fill='#361a47'
              />
              <path
                id='Path_14275'
                data-name='Path 14275'
                d='M884.078,585.342s-1.425-9.374,5.128-10.558,14.323.011,23.979-2.578l.925,2.039s-.928,6.492-9.572,9.139-8.04.506-13.767,4.427C890.77,587.812,885.938,590.462,884.078,585.342Z'
                transform='translate(-883.73 -572.207)'
                fill='#9953b2'
              />
              <path
                id='Path_14276'
                data-name='Path 14276'
                d='M886.956,575.15s-3.38,4.321,3.248,4.207c0,0,5.7,3.691.6,7.9s-6.981-3.655-6.981-3.655S883.071,577.723,886.956,575.15Z'
                transform='translate(-883.765 -571.647)'
                fill='#8546aa'
              />
            </g>
            <path
              id='Path_1868'
              data-name='Path 1868'
              d='M914.314,475.036,910.7,541.654l-12.537,50.065c-1.678,5.914-4.643,6.5-8.263,5.76h0a2.883,2.883,0,0,1-2.242-2.943l1.84-24.426q.087-8.232.918-16.415l1.992-19.593-6.221-28.315a33.241,33.241,0,0,1,6.7-26.3l4.818-5.947Z'
              transform='translate(-857.166 -331.922)'
              fill='#ea9c7a'
            />
            <path
              id='Path_14277'
              data-name='Path 14277'
              d='M932.239,542.57l-2.825-57.21-17.456.563-4.392,6.34a30.945,30.945,0,0,0-4.223,26.289l9.552,26.511-.023,20.69q0,6.577.627,13.13l.69,25.749-.006,0a.952.952,0,0,0-.128.471.986.986,0,0,0,.225.575,3.152,3.152,0,0,0,1.528.878,9.3,9.3,0,0,0,2.919.371c2.553-.052,4.619-.958,4.6-2.015l.012,0s.572-5.056.859-8.067l7.026-38.786A67.993,67.993,0,0,0,932.239,542.57Z'
              transform='translate(-854.054 -329.675)'
              fill='url(#linear-gradient-19)'
            />
            <path
              id='Path_1866'
              data-name='Path 1866'
              d='M882.356,430.165l-13.119,31.673-.451,1.1a5.356,5.356,0,0,0,1.127,5.651l26.137,28.924a4.3,4.3,0,0,0,5.5.708,3.178,3.178,0,0,0,.851-4.371l-20.327-32.3h0l20.211-21.825c2.988-4.575,1.385-10.675-3.581-13.626-.117-.069-.233-.136-.352-.2-5.1-3.115-11.787-1.955-15.131,2.623A9.71,9.71,0,0,0,882.356,430.165Z'
              transform='translate(-860.459 -341.312)'
              fill='#ea9c7a'
            />
            <path
              id='Path_1874'
              data-name='Path 1874'
              d='M984.279,432.667c5-1.824,11.715-3.786,8.154-10.547a.636.636,0,0,1,.023-.875c1.667-1.59,6.014-4.728,4.588-5.885-2.433-.352-11.329,9.607-9.318,3.841.115-.412-.108-1.064-.475-.73C979.308,425.715,977.21,430.068,984.279,432.667Z'
              transform='translate(-839.248 -342.985)'
              fill='#fcbf95'
            />
            <path
              id='Path_14278'
              data-name='Path 14278'
              d='M892.981,474.483s-14.8,23.3-11.585,54.543c0,0,24.7,23.072,62.548,2.32,0,0,12.356-7.5-5.182-59.2C938.762,472.143,928,492.161,892.981,474.483Z'
              transform='translate(-858.077 -332.188)'
              fill='url(#linear-gradient-20)'
            />
            <path
              id='Path_14279'
              data-name='Path 14279'
              d='M899.885,419.4l21.349.054a50.073,50.073,0,0,1,12.064,2.666l4.243,1.513c5.034,1.665,8.349,5.745,8.669,10.28l-6.43,26.034c-1.641,6.649.77,25.385-3.212,29.238-12.983,12.563-32.944,4.982-40.209,2.21a3.586,3.586,0,0,1-2.367-3.03L886.9,446.4a20.35,20.35,0,0,0-4.281-10.178,9.433,9.433,0,0,1-.875-10.076S887.148,419.367,899.885,419.4Z'
              transform='translate(-858.128 -342.215)'
              fill='url(#linear-gradient-21)'
            />
            <path
              id='Path_14280'
              data-name='Path 14280'
              d='M923.656,434.686c-1.408,4.261,1.05,8.853,5.616,10.5h0c5.523,1.539,11.356-.979,13.381-5.778l.3-.709c1.927-4.565-.207-9.769-5.008-12.209l-3.537-1.8c-3.3-1.677-7.389-.189-8.469,3.081Z'
              transform='translate(-850.031 -341.341)'
              fill='#774a84'
            />
            <path
              id='Path_14281'
              data-name='Path 14281'
              d='M913.3,378.21c8.551-1.21,25,8.451,19.576,16.7-27.168,26,5.628,27.981,5.571,43.468-.062,16.5-17.976,1.191-13.225,15.842,3.954,12.194-.212,28.445-20.082,26.887-22.308-1.748-30.5-32.84-17.634-45.193,14.768-14.179,1.309-23.2,5.864-41C893.373,394.913,894.057,380.359,913.3,378.21Z'
              transform='translate(-881.399 -350.072)'
              fill='none'
            />
            <ellipse
              id='Ellipse_2729'
              data-name='Ellipse 2729'
              cx='3.727'
              cy='4.781'
              rx='3.727'
              ry='4.781'
              transform='matrix(0.983, -0.182, 0.182, 0.983, 62.147, 51.796)'
              fill='#fcbf95'
            />
            <path
              id='Path_15161'
              data-name='Path 15161'
              d='M-14704.425-14288.649c2.793.4,16.6-.49,17.682-12.23s-3.721-13.161-1.86-16.617,10.5-.931,11.831-4.388,1.6-9.572-8.109-19.809c-6.381-6.913-2.924-16.22,1.729-20.605s7.577-15.555-9.306-17.683-26.323,6.78-25.126,19.677,5.451,18.611-3.723,31.905-5.318,29.514,2.925,34.964A30.2,30.2,0,0,0-14704.425-14288.649Z'
              transform='translate(14755.666 14410.461)'
              fill='url(#linear-gradient-22)'
            />
          </g>
          <path
            id='Path_14282'
            data-name='Path 14282'
            d='M1008.138,408.917l9.145-4.682c.95-.486.95-1.987,0-3.353s-2.487-2.079-3.436-1.594l-9.145,4.683-9.139-13.16c-.947-1.366-2.487-2.08-3.436-1.594s-.95,1.987,0,3.353l9.139,13.16-9.145,4.682c-.95.486-.95,1.986,0,3.353a4.438,4.438,0,0,0,1.717,1.491,1.976,1.976,0,0,0,1.717.1l9.146-4.682,9.139,13.16a4.43,4.43,0,0,0,1.717,1.491,1.981,1.981,0,0,0,1.717.1c.95-.486.951-1.988,0-3.353Z'
            transform='translate(-724.095 -343.332)'
            fill='#bc1d4e'
          />
        </g>
        <g id='Group_2918' data-name='Group 2918' transform='translate(197.588 201.897)'>
          <path
            id='Path_14288'
            data-name='Path 14288'
            d='M835.873,414.354v-1.284l-.005-48.674a4.445,4.445,0,0,1-2.27,2.954l-12.96,7.073a41.255,41.255,0,0,1-18.3,4.548,37.6,37.6,0,0,1-17.722-4.548l-31.938-17.43a2.785,2.785,0,0,1-1.447-1.915v92.039a2.682,2.682,0,0,0,1.445,2.442l31.937,17.43a37.606,37.606,0,0,0,17.343,4.538v.022c.126,0,.256-.011.381-.013.181,0,.362.014.543.012v-.032a41.133,41.133,0,0,0,17.758-4.527l12.96-7.073a4.252,4.252,0,0,0,2.285-3.64v-.11Z'
            transform='translate(-751.162 -337.089)'
            fill='url(#linear-gradient-23)'
          />
          <path
            id='Path_1715'
            data-name='Path 1715'
            d='M751.194,390.059a2.525,2.525,0,0,1-.037-.3h.059a2.442,2.442,0,0,0,.035.295Z'
            transform='translate(-751.157 -339.513)'
            fill='#ca54cd'
          />
          <path
            id='Path_1716'
            data-name='Path 1716'
            d='M842.249,400.04l-.057-.011a3.948,3.948,0,0,0,.085-.81h.059A3.99,3.99,0,0,1,842.249,400.04Z'
            transform='translate(-757.519 -340.174)'
            fill='#ca54cd'
          />
          <path
            id='Path_1719'
            data-name='Path 1719'
            d='M784.612,373.626,752.675,356.2a2.664,2.664,0,0,1,0-4.74l24.734-13.5a18.406,18.406,0,0,1,17.525,0l38.656,21.1a4.215,4.215,0,0,1,0,7.5l-12.959,7.073A37.834,37.834,0,0,1,784.612,373.626Z'
            transform='translate(-751.162 -335.737)'
            fill={ColorVariables.ACCENT.ACCENT_COLOR_PRIMARY_STROKE}
          />
          <g id='Group_4857' data-name='Group 4857' transform='translate(0.065 57.499)'>
            <path
              id='Path_14289'
              data-name='Path 14289'
              d='M835.587,407.551l-15.249,8.374a37,37,0,0,1-17.459,4.473v0a37.053,37.053,0,0,1-17.977-4.471l-33.675-18.367v5.779l33.093,18.052a38.3,38.3,0,0,0,18.3,4.635h.257v0a38.292,38.292,0,0,0,18.043-4.636l14.945-8.21v-5.8C835.775,407.443,835.683,407.5,835.587,407.551Z'
              transform='translate(-751.227 -397.557)'
              fill='url(#linear-gradient-24)'
            />
            <path
              id='Path_14290'
              data-name='Path 14290'
              d='M820.338,425.34a37,37,0,0,1-17.459,4.472v0a37.032,37.032,0,0,1-17.977-4.473l-33.675-18.366v5.782L784.32,430.8a38.3,38.3,0,0,0,18.3,4.636h.257A38.292,38.292,0,0,0,820.92,430.8l14.945-8.21v-5.8c-.09.061-.182.116-.278.169Z'
              transform='translate(-751.227 -398.215)'
              fill='url(#linear-gradient-24)'
            />
            <path
              id='Path_14291'
              data-name='Path 14291'
              d='M820.338,434.756a37,37,0,0,1-17.459,4.472v0a37.021,37.021,0,0,1-17.977-4.473l-33.675-18.367v5.781l33.093,18.052a38.3,38.3,0,0,0,18.3,4.636h.257v0a38.292,38.292,0,0,0,18.043-4.636l14.945-8.21v-5.8a3.034,3.034,0,0,1-.278.169Z'
              transform='translate(-751.227 -398.873)'
              fill='url(#linear-gradient-24)'
            />
          </g>
        </g>
        <path
          id='Path_14292'
          data-name='Path 14292'
          d='M12550.223,13590.958a26.072,26.072,0,0,1-3.922-2.6v-28.967l12.656,6.908v28.012A47.018,47.018,0,0,1,12550.223,13590.958Z'
          transform='translate(-11854.355 -13009.483)'
          fill='#0fa'
          stroke='rgba(0,0,0,0)'
          stroke-width='1'
        />
      </g>
    </g>
  </svg>
);

export { FallbackArt };
